(function() {
  'use strict';
  
  // Find all wizard sections on the page
  document.querySelectorAll('[data-section-id]').forEach(function(section) {
    initWizard(section);
  });
  
  function initWizard(section) {
    var sectionId = section.dataset.sectionId;
    if (!sectionId) return;
    
    // Storage keys
    var storageKey = 'nv_wiz_data_' + sectionId;
    var pendingSubmitKey = 'nv_wiz_pending_' + sectionId;
    
    // Check for success state
    var successBlock = section.querySelector('.nv-wiz-success[data-success="true"]');
    if (successBlock) {
      try { localStorage.removeItem(pendingSubmitKey); sessionStorage.removeItem(storageKey); } catch(e) {}
      return;
    }
    
    // Check for pending submission
    var hasPendingSubmit = false;
    try { hasPendingSubmit = localStorage.getItem(pendingSubmitKey) === 'true'; } catch(e) {}
    var urlParams = new URLSearchParams(window.location.search);
    var urlHasSuccess = urlParams.get('form_success') === 'wizard';
    
    if (hasPendingSubmit || urlHasSuccess) {
      setTimeout(function() {
        var formWrapper = section.querySelector('.nv-wiz-form-wrapper');
        if (formWrapper) {
          var successTitle = section.dataset.successTitle || 'Application Submitted!';
          var successMessage = section.dataset.successMessage || 'Thank you for applying. We will review your application and get back to you soon.';
          var applyAgainText = section.dataset.applyAgainText || 'Submit Another Application';
          formWrapper.innerHTML = '<div class="nv-wiz-success"><div class="nv-wiz-success-icon">✓</div><h3 class="nv-wiz-success-title">' + escapeHtml(successTitle) + '</h3><p class="nv-wiz-success-text">' + escapeHtml(successMessage) + '</p><button type="button" class="nv-wiz-success-btn" onclick="window.location.href=window.location.pathname;">' + escapeHtml(applyAgainText) + '</button></div>';
        }
        try { localStorage.removeItem(pendingSubmitKey); sessionStorage.removeItem(storageKey); } catch(e) {}
        if (urlHasSuccess) {
          var cleanUrl = window.location.pathname + window.location.hash;
          window.history.replaceState({}, '', cleanUrl);
        }
      }, 100);
      return;
    }
    
    // Load configuration
    var config = null;
    try {
      var configScript = document.getElementById('nv-wiz-blocks-config-' + sectionId);
      if (configScript) config = JSON.parse(configScript.textContent);
    } catch(e) { console.error('Failed to parse wizard config:', e); return; }
    
    if (!config) return;
    
    // DOM references
    var form = section.querySelector('#nv-wiz-form-' + sectionId);
    var stepsContainer = section.querySelector('#nv-wiz-steps-container-' + sectionId);
    var progressText = section.querySelector('#nv-wiz-progress-text-' + sectionId);
    var stepNameEl = section.querySelector('#nv-wiz-step-name-' + sectionId);
    var progressFill = section.querySelector('#nv-wiz-progress-fill-' + sectionId);
    var dotsContainer = section.querySelector('#nv-wiz-dots-' + sectionId);
    var lineFill = section.querySelector('#nv-wiz-line-fill-' + sectionId);
    var formAlert = section.querySelector('#nv-wiz-alert-' + sectionId);
    var formAlertContent = section.querySelector('#nv-wiz-alert-content-' + sectionId);
    var autosaveIndicator = section.querySelector('#nv-wiz-autosave-' + sectionId);
    
    if (!form || !stepsContainer) return;
    
    // Settings
    var condensedMode = config.condensedMode;
    var enableTestMode = section.dataset.enableTestMode === 'true';
    var enableShopify = section.dataset.enableShopify === 'true';
    var enableWebhook = section.dataset.enableWebhook === 'true';
    var webhookUrl = section.dataset.webhookUrl || '';
    var webhookEmails = section.dataset.webhookEmails || '';
    
    // State
    var currentStepIndex = 0;
    var completedSteps = new Set();
    var wizardSteps = [];
    var isEditingFromReview = false;
    var autosaveTimeout = null;
    var resumeFileData = null;
    var conditionalFields = [];
    var currentSelectedRole = null;
    var employerCount = 1;
    var maxEmployers = 3;
    var emergencyContactCount = 1;
    var maxEmergencyContacts = 3;
    var referenceCount = 1;
    var maxReferences = 3;
    var currentValidationErrors = [];
    var currentErrorIndex = 0;
    var pendingRemoval = null;
    var confirmOverlay = null;
    var confirmText = null;
    
    // Get step navigation config
    var stepNavConfig = null;
    config.blocks.forEach(function(b) {
      if (b.type === 'step_navigation') stepNavConfig = b;
    });
    
    // Get reassurance messages config
    var reassuranceConfig = null;
    config.blocks.forEach(function(b) {
      if (b.type === 'reassurance_messages') reassuranceConfig = b;
    });
    
    // =============================================
    // UTILITY FUNCTIONS
    // =============================================
    
    function escapeHtml(str) {
      if (!str) return '';
      var div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }
    
    function getReassuranceIcon(iconName, color) {
      var icons = {
        'lock': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="color: ' + color + ';"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>',
        'shield': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="color: ' + color + ';"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>',
        'check': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="color: ' + color + ';"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>',
        'clock': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="color: ' + color + ';"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>',
        'info': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="color: ' + color + ';"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>',
        'thumbs-up': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="color: ' + color + ';"><path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"></path></svg>'
      };
      return icons[iconName] || '';
    }
    
    function renderReassuranceMessage(text, icon, style, textColor, iconColor, bgColor, borderColor, fontSize, marginTop, marginBottom, paddingX, paddingY, nudge, fullWidth) {
      var styleAttr = 'font-size: ' + (fontSize || 13) + 'px; color: ' + (textColor || '#6b7280') + ';';
      styleAttr += ' margin-top: ' + ((marginTop || 0) + (nudge || 0)) + 'px;';
      styleAttr += ' margin-bottom: ' + (marginBottom || 0) + 'px;';
      styleAttr += ' padding: ' + (paddingY || 8) + 'px ' + (paddingX || 14) + 'px;';
      if (style === 'badge') {
        styleAttr += ' background: ' + (bgColor || '#F0FDF4') + ';';
      } else if (style === 'outlined') {
        styleAttr += ' border-width: 1px; border-color: ' + (borderColor || '#BBF7D0') + ';';
      }
      if (fullWidth) {
        styleAttr += ' width: 100%; box-sizing: border-box;';
      }
      var html = '<div class="nv-wiz-reassurance nv-wiz-reassurance--' + (style || 'badge') + '" style="' + styleAttr + '">';
      if (icon && icon !== 'none') {
        html += getReassuranceIcon(icon, iconColor || '#0D9488');
      }
      html += '<span>' + escapeHtml(text) + '</span>';
      html += '</div>';
      return html;
    }
    
    // =============================================
    // CONDITIONAL FIELDS SYSTEM
    // =============================================
    
    function parseConditionalFields() {
      conditionalFields = [];
      config.blocks.forEach(function(block) {
        if (block.type === 'conditional_field') {
          var fieldName = block.fieldName;
          if (!fieldName && block.fieldLabel) {
            fieldName = block.fieldLabel.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
          }
          if (!fieldName) fieldName = 'conditional_' + block.id;
          var labelOverridesMap = {};
          if (block.labelOverrides) {
            block.labelOverrides.split(',').forEach(function(pair) {
              var parts = pair.split(':');
              if (parts.length === 2) {
                var roleName = parts[0].trim().toLowerCase();
                var label = parts[1].trim();
                if (roleName && label) {
                  labelOverridesMap[roleName] = label;
                }
              }
            });
          }
          conditionalFields.push({
            id: block.id,
            fieldName: fieldName,
            fieldLabel: block.fieldLabel || 'Field',
            labelOverrides: labelOverridesMap,
            fieldType: block.fieldType || 'text',
            placeholder: block.placeholder || '',
            options: block.options ? block.options.split(',').map(function(s) { return s.trim(); }) : [],
            requiredWhenVisible: block.requiredWhenVisible !== false,
            helpText: block.helpText || '',
            visibilityMode: block.visibilityMode || 'show_for_specific',
            roleList: block.roleList ? block.roleList.split(',').map(function(s) { return s.trim().toLowerCase(); }) : [],
            placement: block.placement || 'work_eligibility',
            sectionTitle: block.sectionTitle || 'Additional Requirements',
            sectionIcon: block.sectionIcon || 'clipboard',
            groupId: block.groupId || null,
            groupTitle: block.groupTitle || null,
            currentState: 'hidden',
            hasValue: false
          });
        }
      });
    }
    
    function isFieldVisibleForRole(field, roleName) {
      if (!roleName) return false;
      var roleNameLower = roleName.toLowerCase();
      var isInList = field.roleList.some(function(r) { return r === roleNameLower; });
      switch (field.visibilityMode) {
        case 'always': return true;
        case 'show_for_specific': return isInList;
        case 'hide_for_specific': return !isInList;
        default: return false;
      }
    }
    
    function updateConditionalFieldsVisibility(selectedRole) {
      currentSelectedRole = selectedRole;
      conditionalFields.forEach(function(field) {
        var shouldBeVisible = isFieldVisibleForRole(field, selectedRole);
        var fieldEl = stepsContainer.querySelector('[data-conditional-field-id="' + field.id + '"]');
        if (!fieldEl) return;
        var inputEl = fieldEl.querySelector('input, select, textarea');
        var hasValue = inputEl && inputEl.value && inputEl.value.trim();
        field.hasValue = hasValue;
        var isTextBased = ['text', 'email', 'tel', 'number', 'textarea', 'select', 'date'].indexOf(field.fieldType) !== -1;
        if (shouldBeVisible) {
          field.currentState = 'visible';
          fieldEl.dataset.visibilityState = 'visible';
          if (inputEl && field.requiredWhenVisible) inputEl.setAttribute('required', 'required');
          var labelEl = fieldEl.querySelector('[data-field-label]');
          if (labelEl) {
            var newLabel = getFieldLabelForRole(field, selectedRole);
            var requiredIndicator = labelEl.querySelector('.nv-wiz-required, .nv-wiz-required-text, .nv-wiz-required-badge');
            labelEl.textContent = newLabel;
            if (requiredIndicator) {
              labelEl.appendChild(requiredIndicator.cloneNode(true));
            } else if (field.requiredWhenVisible) {
              labelEl.insertAdjacentHTML('beforeend', config.requiredIndicator);
            }
          }
        } else if (hasValue && isTextBased) {
          field.currentState = 'optional';
          fieldEl.dataset.visibilityState = 'optional';
          if (inputEl) inputEl.removeAttribute('required');
        } else {
          field.currentState = 'hidden';
          fieldEl.dataset.visibilityState = 'hidden';
          if (inputEl) inputEl.removeAttribute('required');
        }
      });
    }
    
    function getFieldLabelForRole(field, roleName) {
      if (!roleName) return field.fieldLabel;
      var roleKey = roleName.toLowerCase();
      if (field.labelOverrides && field.labelOverrides[roleKey]) {
        return field.labelOverrides[roleKey];
      }
      return field.fieldLabel;
    }
    
    function renderConditionalField(field) {
      var inputName = 'contact[' + field.fieldName + ']';
      var currentLabel = getFieldLabelForRole(field, currentSelectedRole);
      var html = '<div class="nv-wiz-field nv-wiz-field--full nv-wiz-conditional-field" data-conditional-field-id="' + field.id + '" data-visibility-state="hidden">';
      html += '<label class="nv-wiz-label" data-field-label>' + escapeHtml(currentLabel);
      if (field.requiredWhenVisible) html += renderRequiredIndicator(true);
      html += '</label>';
      switch (field.fieldType) {
        case 'text': case 'email': case 'tel':
          html += '<input type="' + field.fieldType + '" name="' + inputName + '" class="nv-wiz-input" placeholder="' + escapeHtml(field.placeholder) + '" data-field="' + field.fieldName + '">';
          break;
        case 'date':
          html += renderCalendarPicker(field.fieldName, field.placeholder || 'Select date', field.requiredWhenVisible, null, inputName);
          break;
        case 'textarea':
          html += '<textarea name="' + inputName + '" class="nv-wiz-textarea" placeholder="' + escapeHtml(field.placeholder) + '" data-field="' + field.fieldName + '"></textarea>';
          break;
        case 'select':
          html += '<select name="' + inputName + '" class="nv-wiz-select" data-field="' + field.fieldName + '"><option value="" disabled selected>' + escapeHtml(field.placeholder || 'Select...') + '</option>';
          field.options.forEach(function(opt) { html += '<option value="' + escapeHtml(opt) + '">' + escapeHtml(opt) + '</option>'; });
          html += '</select>';
          break;
        case 'radio':
          html += '<div class="nv-wiz-radio-group">';
          field.options.forEach(function(opt) { html += '<label class="nv-wiz-radio-item"><input type="radio" name="' + inputName + '" value="' + escapeHtml(opt) + '" data-field="' + field.fieldName + '"><span>' + escapeHtml(opt) + '</span></label>'; });
          html += '</div>';
          break;
        case 'checkbox':
          html += '<div class="nv-wiz-checkbox-group">';
          field.options.forEach(function(opt, i) { html += '<label class="nv-wiz-checkbox-item"><input type="checkbox" name="' + inputName.replace(']', '_' + i + ']') + '" value="' + escapeHtml(opt) + '" data-field="' + field.fieldName + '"><span>' + escapeHtml(opt) + '</span></label>'; });
          html += '</div>';
          break;
      }
      if (field.helpText) html += '<p class="nv-wiz-help-text">' + escapeHtml(field.helpText) + '</p>';
      html += '<div class="nv-wiz-conditional-warning"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" style="display:inline-block;vertical-align:middle;margin-right:6px;"><path d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/></svg>This field is no longer required for the selected role, but will be included in your application.</div>';
      html += '</div>';
      return html;
    }
    
    function getConditionalFieldsForPlacement(placement) {
      return conditionalFields.filter(function(f) { return f.placement === placement; });
    }
    
    function renderConditionalFieldsForPlacement(placement) {
      var fields = getConditionalFieldsForPlacement(placement);
      if (fields.length === 0) return '';
      var groups = {}, ungrouped = [];
      fields.forEach(function(field) {
        if (field.groupId) {
          if (!groups[field.groupId]) groups[field.groupId] = { title: field.groupTitle, fields: [] };
          if (field.groupTitle && !groups[field.groupId].title) groups[field.groupId].title = field.groupTitle;
          groups[field.groupId].fields.push(field);
        } else { ungrouped.push(field); }
      });
      var html = '';
      Object.keys(groups).forEach(function(groupId) {
        var group = groups[groupId];
        html += '<div class="nv-wiz-conditional-group" data-conditional-group="' + escapeHtml(groupId) + '">';
        if (group.title) html += '<h5 class="nv-wiz-conditional-group-title">' + escapeHtml(group.title) + '</h5>';
        html += '<div class="nv-wiz-conditional-group-fields">';
        group.fields.forEach(function(field) { html += renderConditionalField(field); });
        html += '</div></div>';
      });
      ungrouped.forEach(function(field) { html += renderConditionalField(field); });
      return html;
    }
    
    function getStepDisplayName(index) {
      var step = wizardSteps[index];
      if (!step) return 'Step ' + (index + 1);
      var name = step.name;
      if (name.match(/^Step \d+$/)) {
        if (step.isReview) return 'Review & Submit';
        else if (step.isGrouped) return 'Your Information';
        else if (step.blocks && step.blocks.length > 0) {
          var firstBlock = step.blocks[0];
          return firstBlock.sectionTitle || firstBlock.stepTitle || name;
        }
      }
      return name;
    }
    
    // =============================================
    // FORM ALERTS & SCROLLING
    // =============================================
    
    function showFormAlert(messages, isError, errorFields) {
      if (!formAlert || !formAlertContent) return;
      currentValidationErrors = errorFields || [];
      currentErrorIndex = 0;
      var html = '';
      if (Array.isArray(messages) && messages.length > 1) {
        html = '<strong>' + (isError ? 'Please fix the following:' : 'Notice:') + '</strong><ul>';
        messages.forEach(function(msg, i) {
          var fieldSelector = errorFields && errorFields[i] ? errorFields[i] : null;
          if (fieldSelector) {
            var escapedSelector = fieldSelector.replace(/"/g, '&quot;');
            html += '<li><a href="javascript:void(0)" class="nv-wiz-error-link" data-error-field="' + escapedSelector + '" data-error-index="' + i + '">' + msg + '</a></li>';
          } else {
            html += '<li>' + msg + '</li>';
          }
        });
        html += '</ul>';
      } else {
        var msg = Array.isArray(messages) ? messages[0] : messages;
        var fieldSelector = errorFields && errorFields[0] ? errorFields[0] : null;
        if (fieldSelector) {
          var escapedSelector = fieldSelector.replace(/"/g, '&quot;');
          html = '<strong><a href="javascript:void(0)" class="nv-wiz-error-link" data-error-field="' + escapedSelector + '" data-error-index="0">' + msg + '</a></strong>';
        } else {
          html = '<strong>' + msg + '</strong>';
        }
      }
      formAlertContent.innerHTML = html;
      formAlert.classList.toggle('nv-wiz-form-alert--error', isError);
      formAlert.classList.add('is-visible');
      var alertOffset = parseInt(section.dataset.scrollOffset || '150', 10);
      scrollToElement(formAlert, alertOffset);
    }
    
    function scrollToElement(el, offset) {
      if (!el) return;
      offset = offset || 100;
      var rect = el.getBoundingClientRect();
      var absoluteTop = rect.top + window.pageYOffset;
      window.scrollTo({ top: absoluteTop - offset, behavior: 'smooth' });
    }
    
    function scrollToAndFocusField(selector) {
      if (!selector) return;
      selector = selector.replace(/&quot;/g, '"');
      var activeStep = stepsContainer.querySelector('.nv-wiz-step.is-active');
      var field = null;
      try {
        if (activeStep) field = activeStep.querySelector(selector);
        if (!field) field = stepsContainer.querySelector(selector);
        if (!field && selector.includes('data-field-group')) {
          var groupMatch = selector.match(/data-field-group="([^"]+)"/);
          if (groupMatch) field = stepsContainer.querySelector('[data-field-group="' + groupMatch[1] + '"]');
        }
      } catch(e) { console.warn('Invalid selector:', selector, e); return; }
      if (!field) { console.warn('Field not found:', selector); return; }
      var sectionGroup = field.closest('.nv-wiz-section-group');
      if (sectionGroup && !sectionGroup.classList.contains('is-open')) sectionGroup.classList.add('is-open');
      var scrollTarget = field;
      if (field.type === 'checkbox' || field.type === 'radio') {
        var groupWrapper = field.closest('[data-field-group]') || field.closest('.nv-wiz-checkbox-group') || field.closest('.nv-wiz-radio-group');
        if (groupWrapper) scrollTarget = groupWrapper;
      }
      var scrollOffset = parseInt(section.dataset.scrollOffset || '150', 10);
      scrollToElement(scrollTarget, scrollOffset);
      setTimeout(function() {
        if (field.type === 'checkbox' || field.type === 'radio') {
          var group = field.closest('.nv-wiz-checkbox-group, .nv-wiz-radio-group');
          if (group) {
            var firstInput = group.querySelector('input:not(:checked)') || group.querySelector('input');
            if (firstInput) firstInput.focus();
          }
        } else if (field.focus) { field.focus(); }
        var wrapper = field.closest('.nv-wiz-field') || field.closest('[data-field-group]');
        if (wrapper) {
          wrapper.classList.add('nv-wiz-field--highlight');
          setTimeout(function() { wrapper.classList.remove('nv-wiz-field--highlight'); }, 2000);
        }
      }, 500);
    }
    
    function hideFormAlert() {
      if (formAlert) formAlert.classList.remove('is-visible');
    }
    
    function updateRoleTether(roleName) {
      var roleTether = section.querySelector('#nv-wiz-role-tether-' + sectionId);
      var roleTetherValue = section.querySelector('#nv-wiz-role-tether-value-' + sectionId);
      if (!roleTether || !roleTetherValue) return;
      if (roleName && roleName.trim()) {
        roleTetherValue.textContent = roleName;
        roleTether.classList.add('is-visible');
      } else {
        roleTether.classList.remove('is-visible');
      }
    }
    
    // =============================================
    // SAVE/LOAD PROGRESS
    // =============================================
    
    function saveProgress() {
      try {
        var data = {};
        form.querySelectorAll('input, select, textarea').forEach(function(field) {
          if (field.name && field.name.startsWith('contact[')) {
            if (field.type === 'checkbox') { data[field.name] = field.checked; }
            else if (field.type === 'radio') { if (field.checked) data[field.name] = field.value; }
            else { data[field.name] = field.value; }
          }
        });
        data._currentStep = currentStepIndex;
        data._completedSteps = Array.from(completedSteps);
        sessionStorage.setItem(storageKey, JSON.stringify(data));
        if (autosaveIndicator) {
          autosaveIndicator.classList.add('is-visible');
          if (autosaveTimeout) clearTimeout(autosaveTimeout);
          autosaveTimeout = setTimeout(function() { autosaveIndicator.classList.remove('is-visible'); }, 2000);
        }
      } catch(e) {}
    }
    
    function loadProgress() {
      try {
        var saved = sessionStorage.getItem(storageKey);
        if (saved) {
          var data = JSON.parse(saved);
          Object.keys(data).forEach(function(key) {
            if (key === '_currentStep' || key === '_completedSteps') return;
            var fields = form.querySelectorAll('[name="' + key + '"]');
            fields.forEach(function(field) {
              if (field.type === 'checkbox') {
                field.checked = data[key];
                updateCheckboxVisual(field);
              } else if (field.type === 'radio') {
                if (field.value === data[key]) {
                  field.checked = true;
                  updateRadioVisual(field);
                }
              } else { field.value = data[key]; }
            });
          });
          if (data._completedSteps) {
            data._completedSteps.forEach(function(idx) { completedSteps.add(idx); });
          }
        }
      } catch(e) {}
    }
    
    function updateCheckboxVisual(input) {
      var item = input.closest('.nv-wiz-checkbox-item');
      if (item) item.classList.toggle('is-checked', input.checked);
    }
    
    function updateRadioVisual(input) {
      var group = form.querySelectorAll('[name="' + input.name + '"]');
      group.forEach(function(r) {
        var item = r.closest('.nv-wiz-radio-item');
        if (item) item.classList.toggle('is-checked', r.checked);
      });
    }
    
    // =============================================
    // VALIDATION HELPERS
    // =============================================
    
    function validateEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }
    
    function validatePhone(phone) {
      var digits = phone.replace(/\D/g, '');
      return digits.length >= 10 && digits.length <= 11;
    }
    
    function formatPhone(input) {
      var digits = input.value.replace(/\D/g, '');
      if (digits.length === 0) return;
      var formatted = '';
      if (digits.length > 0) formatted = '(' + digits.substring(0, 3);
      if (digits.length >= 3) formatted += ') ';
      if (digits.length > 3) formatted += digits.substring(3, 6);
      if (digits.length >= 6) formatted += '-';
      if (digits.length > 6) formatted += digits.substring(6, 10);
      input.value = formatted;
    }
    
    function showFieldError(field, message) {
      var wrapper = field.closest('.nv-wiz-field');
      if (!wrapper) return;
      wrapper.classList.add('has-error');
      var existing = wrapper.querySelector('.nv-wiz-error-msg');
      if (existing) existing.remove();
      var errorEl = document.createElement('span');
      errorEl.className = 'nv-wiz-error-msg';
      errorEl.textContent = message;
      wrapper.appendChild(errorEl);
    }
    
    function clearFieldError(field) {
      var wrapper = field.closest('.nv-wiz-field');
      if (!wrapper) return;
      var hadError = wrapper.classList.contains('has-error');
      wrapper.classList.remove('has-error');
      var existing = wrapper.querySelector('.nv-wiz-error-msg');
      if (existing) existing.remove();
      if (hadError && field.value && field.value.trim()) showFieldSuccess(wrapper);
    }
    
    function showFieldSuccess(wrapper) {
      wrapper.classList.add('nv-wiz-field--success');
      setTimeout(function() { wrapper.classList.add('nv-wiz-success-fade'); }, 100);
      setTimeout(function() { wrapper.classList.remove('nv-wiz-field--success', 'nv-wiz-success-fade'); }, 2100);
    }
    
    function showGroupSuccess(groupEl) {
      groupEl.classList.remove('has-error');
      groupEl.classList.add('nv-wiz-field--success');
      setTimeout(function() { groupEl.classList.add('nv-wiz-success-fade'); }, 100);
      setTimeout(function() { groupEl.classList.remove('nv-wiz-field--success', 'nv-wiz-success-fade'); }, 2100);
    }
    
    function getFieldLabel(field) {
      var wrapper = field.closest('.nv-wiz-field');
      if (wrapper) {
        var label = wrapper.querySelector('.nv-wiz-label');
        if (label) {
          var text = label.textContent.replace(/\*|\(required\)|Required/gi, '').trim();
          return text || 'This field';
        }
      }
      return 'This field';
    }
    
    // =============================================
    // STEP ORGANIZATION
    // =============================================
    
    function organizeSteps() {
      var stepBlocks = config.blocks.filter(function(b) {
        return b.type.startsWith('step_') && b.type !== 'step_navigation' && b.type !== 'step_review';
      });
      var reviewBlock = config.blocks.find(function(b) { return b.type === 'step_review'; });
      
      if (condensedMode) {
        var roleBlock = stepBlocks.find(function(b) { return b.type === 'step_role_selection'; });
        var otherBlocks = stepBlocks.filter(function(b) { return b.type !== 'step_role_selection'; });
        wizardSteps = [];
        if (roleBlock) {
          wizardSteps.push({ name: roleBlock.sectionTitle || 'Select Role', blocks: [roleBlock], isGrouped: false });
        }
        if (otherBlocks.length > 0) {
          wizardSteps.push({ name: 'Your Information', blocks: otherBlocks, isGrouped: true });
        }
        if (reviewBlock) {
          wizardSteps.push({ name: reviewBlock.sectionTitle || 'Review & Submit', blocks: [reviewBlock], isGrouped: false, isReview: true });
        }
      } else {
        var groups = {};
        var ownStepBlocks = [];
        stepBlocks.forEach(function(block) {
          var groupNum = block.groupNumber;
          if (groupNum === 'own_step' || !groupNum) { ownStepBlocks.push(block); }
          else {
            if (!groups[groupNum]) groups[groupNum] = [];
            groups[groupNum].push(block);
          }
        });
        wizardSteps = [];
        ownStepBlocks.forEach(function(block) {
          wizardSteps.push({ name: block.sectionTitle || block.stepTitle || 'Step', blocks: [block], isGrouped: false });
        });
        Object.keys(groups).sort(function(a, b) { return parseInt(a) - parseInt(b); }).forEach(function(groupNum) {
          var groupBlocks = groups[groupNum];
          if (groupBlocks.length === 1) {
            wizardSteps.push({ name: groupBlocks[0].sectionTitle || groupBlocks[0].stepTitle || 'Step', blocks: groupBlocks, isGrouped: false });
          } else {
            wizardSteps.push({ name: 'Step ' + groupNum, blocks: groupBlocks, isGrouped: true });
          }
        });
        if (reviewBlock) {
          wizardSteps.push({ name: reviewBlock.sectionTitle || 'Review & Submit', blocks: [reviewBlock], isGrouped: false, isReview: true });
        }
      }
      return wizardSteps;
    }
    
    // =============================================
    // RENDER FUNCTIONS
    // =============================================
    
    function getSectionIcon(iconName) {
      var icons = {
        'user': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>',
        'home': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>',
        'phone': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>',
        'briefcase': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg>',
        'clock': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>',
        'star': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>',
        'shield': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>',
        'file': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline></svg>',
        'check': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>'
      };
      return icons[iconName] || icons['file'];
    }
    
    function renderRequiredIndicator(isRequired) {
      if (!isRequired) return '';
      return config.requiredIndicator;
    }
    
    function renderField(type, name, label, placeholder, required, options) {
      var html = '<div class="nv-wiz-field' + (type === 'textarea' || type === 'select' || type === 'checkbox_group' || type === 'radio_group' ? ' nv-wiz-field--full' : '') + '">';
      html += '<label class="nv-wiz-label">' + escapeHtml(label) + renderRequiredIndicator(required) + '</label>';
      switch(type) {
        case 'text': case 'email': case 'tel':
          html += '<input type="' + type + '" name="contact[' + name + ']" class="nv-wiz-input" placeholder="' + escapeHtml(placeholder || '') + '" data-field="' + name + '"' + (required ? ' required' : '') + '>';
          break;
        case 'date':
          html += renderCalendarPicker(name, placeholder || 'Select date', required);
          break;
        case 'textarea':
          html += '<textarea name="contact[' + name + ']" class="nv-wiz-textarea" placeholder="' + escapeHtml(placeholder || '') + '" data-field="' + name + '"' + (required ? ' required' : '') + '></textarea>';
          break;
        case 'select':
          html += '<select name="contact[' + name + ']" class="nv-wiz-select" data-field="' + name + '"' + (required ? ' required' : '') + '>';
          html += '<option value="" disabled selected>' + escapeHtml(placeholder || 'Select...') + '</option>';
          if (options && options.length) {
            options.forEach(function(opt) { html += '<option value="' + escapeHtml(opt) + '">' + escapeHtml(opt) + '</option>'; });
          }
          html += '</select>';
          break;
        case 'radio_group':
          html += '<div class="nv-wiz-radio-group">';
          if (options && options.length) {
            options.forEach(function(opt) {
              html += '<label class="nv-wiz-radio-item"><input type="radio" name="contact[' + name + ']" value="' + escapeHtml(opt) + '" data-field="' + name + '"' + (required ? ' required' : '') + '><span>' + escapeHtml(opt) + '</span></label>';
            });
          }
          html += '</div>';
          break;
        case 'checkbox_group':
          html += '<div class="nv-wiz-checkbox-group">';
          if (options && options.length) {
            options.forEach(function(opt, i) {
              html += '<label class="nv-wiz-checkbox-item"><input type="checkbox" name="contact[' + name + '_' + i + ']" value="' + escapeHtml(opt) + '" data-field="' + name + '"><span>' + escapeHtml(opt) + '</span></label>';
            });
          }
          html += '</div>';
          break;
      }
      html += '</div>';
      return html;
    }
    
    function renderBlockContent(block) {
      var html = '<div class="nv-wiz-fields">';
      switch(block.type) {
        case 'step_role_selection':
          html += '<div class="nv-wiz-field nv-wiz-field--full">';
          html += '<label class="nv-wiz-label">' + escapeHtml(block.labelRole) + renderRequiredIndicator(true) + '</label>';
          html += '<select name="contact[role]" class="nv-wiz-select" data-field="role" data-role-select required>';
          html += '<option value="" disabled selected>' + escapeHtml(block.placeholderRole) + '</option>';
          if (block.roles && block.roles.length) {
            block.roles.forEach(function(role) {
              if (role.title) html += '<option value="' + escapeHtml(role.title) + '">' + escapeHtml(role.title) + '</option>';
            });
          }
          html += '</select></div>';
          html += renderConditionalFieldsForPlacement('role_step');
          break;
        case 'step_about_you':
          if (block.showFirstName) html += renderField('text', 'first_name', block.labelFirstName, block.placeholderFirstName, block.requireFirstName);
          if (block.showLastName) html += renderField('text', 'last_name', block.labelLastName, block.placeholderLastName, block.requireLastName);
          var ageMode = block.ageVerificationMode || 'eligibility';
          var msgPosition = block.ageMessagePosition || 'below';
          if (block.showDob && ageMode === 'date_of_birth') {
            var today = new Date().toISOString().split('T')[0];
            if (block.enableAgeVerification && msgPosition === 'above') {
              html += '<div class="nv-wiz-age-message nv-wiz-field--full" data-age-message style="display: none;"></div>';
            }
            html += '<div class="nv-wiz-field">';
            html += '<label class="nv-wiz-label">' + escapeHtml(block.labelDob) + renderRequiredIndicator(block.requireDob) + '</label>';
            html += renderCalendarPicker('date_of_birth', escapeHtml(block.labelDob || 'Select date'), block.requireDob, today, null, 'data-dob-field');
            html += '</div>';
            if (block.enableAgeVerification && msgPosition === 'below') {
              html += '<div class="nv-wiz-age-message nv-wiz-field--full" data-age-message style="display: none;"></div>';
            }
          }
          if (block.enableAgeVerification && ageMode === 'eligibility') {
            var minAge = block.minAgeNoConsent || 16;
            var youngAge = block.youngPersonAge || 17;
            var eligLabel = (block.ageEligibilityLabel || 'Are you at least [age] years old?').replace('[age]', minAge);
            var underLabel = (block.ageUnderThresholdLabel || 'Are you under [young_age] years old?').replace('[young_age]', youngAge);
            var showEligQ = block.showAgeEligibilityQuestion !== false;
            var showUnderQ = block.showAgeUnderQuestion !== false;
            if (msgPosition === 'above') {
              html += '<div class="nv-wiz-age-message nv-wiz-field--full" data-age-message style="display: none;"></div>';
            }
            if (showEligQ) {
              html += '<div class="nv-wiz-field nv-wiz-field--full" data-age-eligibility-field>';
              html += '<label class="nv-wiz-label">' + escapeHtml(eligLabel) + renderRequiredIndicator(true) + '</label>';
              html += '<div class="nv-wiz-radio-group">';
              html += '<label class="nv-wiz-radio-item"><input type="radio" name="contact[age_eligible]" value="Yes" data-field="age_eligible" data-age-eligible required><span>Yes</span></label>';
              html += '<label class="nv-wiz-radio-item"><input type="radio" name="contact[age_eligible]" value="No" data-field="age_eligible" data-age-eligible><span>No</span></label>';
              html += '</div></div>';
            }
            if (showUnderQ) {
              var underFieldStyle = showEligQ ? ' style="display: none;"' : '';
              html += '<div class="nv-wiz-field nv-wiz-field--full" data-age-under-field' + underFieldStyle + '>';
              html += '<label class="nv-wiz-label">' + escapeHtml(underLabel) + renderRequiredIndicator(true) + '</label>';
              html += '<div class="nv-wiz-radio-group">';
              html += '<label class="nv-wiz-radio-item"><input type="radio" name="contact[age_under_threshold]" value="Yes" data-field="age_under_threshold" data-age-under><span>Yes</span></label>';
              html += '<label class="nv-wiz-radio-item"><input type="radio" name="contact[age_under_threshold]" value="No" data-field="age_under_threshold" data-age-under><span>No</span></label>';
              html += '</div></div>';
            }
            if (msgPosition === 'below') {
              html += '<div class="nv-wiz-age-message nv-wiz-field--full" data-age-message style="display: none;"></div>';
            }
          }
          if (block.enableAgeVerification) {
            html += '<div class="nv-wiz-guardian-consent nv-wiz-field--full" data-guardian-consent style="display: none;">';
            html += '<div class="nv-wiz-guardian-header">';
            html += '<h4 class="nv-wiz-guardian-title">' + escapeHtml(block.guardianSectionTitle || 'Parent/Guardian Consent') + '</h4>';
            html += '</div>';
            html += '<div class="nv-wiz-guardian-fields">';
            html += '<div class="nv-wiz-field"><label class="nv-wiz-label">' + escapeHtml(block.guardianNameLabel || 'Parent/Guardian Full Name') + renderRequiredIndicator(true) + '</label>';
            html += '<input type="text" name="contact[guardian_name]" class="nv-wiz-input" data-field="guardian_name" data-guardian-field placeholder="Full legal name"></div>';
            html += '<div class="nv-wiz-field"><label class="nv-wiz-label">' + escapeHtml(block.guardianPhoneLabel || 'Parent/Guardian Phone') + renderRequiredIndicator(true) + '</label>';
            html += '<input type="tel" name="contact[guardian_phone]" class="nv-wiz-input" data-field="guardian_phone" data-guardian-field placeholder="(123) 456-7890"></div>';
            if (block.consentMode === 'detailed') {
              var relOptions = (block.guardianRelationshipOptions || 'Parent, Legal Guardian, Other').split(',').map(function(o) { return o.trim(); });
              html += '<div class="nv-wiz-field"><label class="nv-wiz-label">' + escapeHtml(block.guardianRelationshipLabel || 'Relationship to Applicant') + renderRequiredIndicator(true) + '</label>';
              html += '<select name="contact[guardian_relationship]" class="nv-wiz-select" data-field="guardian_relationship" data-guardian-field>';
              html += '<option value="">Select relationship...</option>';
              relOptions.forEach(function(opt) { html += '<option value="' + escapeHtml(opt) + '">' + escapeHtml(opt) + '</option>'; });
              html += '</select></div>';
              html += '<div class="nv-wiz-field"><label class="nv-wiz-label">' + escapeHtml(block.guardianEmailLabel || 'Parent/Guardian Email') + renderRequiredIndicator(true) + '</label>';
              html += '<input type="email" name="contact[guardian_email]" class="nv-wiz-input" data-field="guardian_email" data-guardian-field placeholder="guardian@example.com"></div>';
            }
            html += '</div>';
            html += '<div class="nv-wiz-guardian-checkbox">';
            html += '<label class="nv-wiz-checkbox-label"><input type="checkbox" name="contact[guardian_consent]" value="Yes" data-field="guardian_consent" data-guardian-field>';
            html += '<span>' + escapeHtml(block.consentCheckboxText || 'I confirm that I have parental/guardian permission to submit this application.') + '</span></label>';
            html += '</div></div>';
          }
          if (block.showPhone) html += renderField('tel', 'phone', block.labelPhone, block.placeholderPhone, block.requirePhone);
          if (block.showEmail) {
            html += '<div class="nv-wiz-field nv-wiz-field--full">';
            html += '<label class="nv-wiz-label">' + escapeHtml(block.labelEmail) + renderRequiredIndicator(block.requireEmail) + '</label>';
            html += '<input type="email" name="contact[email]" class="nv-wiz-input" placeholder="' + escapeHtml(block.placeholderEmail) + '" data-field="email"' + (block.requireEmail ? ' required' : '') + '></div>';
          }
          html += renderConditionalFieldsForPlacement('about_you');
          break;
        case 'step_address':
          if (block.showMailingAddress) {
            html += '<div class="nv-wiz-field nv-wiz-field--full"><label class="nv-wiz-label">' + escapeHtml(block.labelMailingAddress) + renderRequiredIndicator(block.requireMailingAddress) + '</label>';
            html += '<input type="text" name="contact[mailing_address]" class="nv-wiz-input" placeholder="' + escapeHtml(block.placeholderMailingAddress) + '" data-field="mailing_address"' + (block.requireMailingAddress ? ' required' : '') + '></div>';
          }
          if (block.showResidentialAddress) {
            html += '<div class="nv-wiz-field nv-wiz-field--full"><label class="nv-wiz-label">' + escapeHtml(block.labelResidentialAddress) + renderRequiredIndicator(block.requireResidentialAddress) + '</label>';
            html += '<input type="text" name="contact[residential_address]" class="nv-wiz-input" placeholder="' + escapeHtml(block.placeholderResidentialAddress) + '" data-field="residential_address"' + (block.requireResidentialAddress ? ' required' : '') + '></div>';
          }
          if (block.showCommunity) html += renderField('text', 'community', block.labelCommunity, block.placeholderCommunity, block.requireCommunity);
          if (block.showPostalCode) html += renderField('text', 'postal_code', block.labelPostalCode, block.placeholderPostalCode, block.requirePostalCode);
          html += renderConditionalFieldsForPlacement('address');
          break;
        case 'step_emergency_contact':
          maxEmergencyContacts = block.maxEmergencyContacts || 3;
          html += '<div class="nv-wiz-field nv-wiz-field--full" data-emergency-contacts-wrapper>';
          html += '<div data-emergency-contacts-list>' + renderEmergencyContactCard(1, block) + '</div>';
          if (block.allowMultipleContacts) {
            html += '<button type="button" class="nv-wiz-add-emergency" data-add-emergency><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 5v14M5 12h14"></path></svg>Add Another Contact</button>';
          }
          html += '</div>';
          html += renderConditionalFieldsForPlacement('emergency_contact');
          break;
        case 'step_work_eligibility':
          if (block.showWorkEligible) {
            html += '<div class="nv-wiz-field nv-wiz-field--full"><label class="nv-wiz-label">' + escapeHtml(block.labelWorkEligible) + renderRequiredIndicator(block.requireWorkEligible) + '</label>';
            html += '<div class="nv-wiz-radio-group">';
            html += '<label class="nv-wiz-radio-item"><input type="radio" name="contact[work_eligible]" value="Yes" data-field="work_eligible"' + (block.requireWorkEligible ? ' required' : '') + '><span>Yes</span></label>';
            html += '<label class="nv-wiz-radio-item"><input type="radio" name="contact[work_eligible]" value="No" data-field="work_eligible"><span>No</span></label>';
            html += '</div></div>';
          }
          if (block.showNtiNumber) {
            html += '<div class="nv-wiz-field nv-wiz-field--full"><label class="nv-wiz-label">' + escapeHtml(block.labelNtiNumber) + renderRequiredIndicator(block.requireNtiNumber) + '</label>';
            html += '<input type="text" name="contact[nti_number]" class="nv-wiz-input" placeholder="' + escapeHtml(block.placeholderNtiNumber) + '" data-field="nti_number"' + (block.requireNtiNumber ? ' required' : '') + '>';
            html += '<p style="font-size: 13px; color: var(--wiz-subheading-color); margin-top: 6px;">' + escapeHtml(block.ntiHelpText) + '</p></div>';
          }
          html += renderConditionalFieldsForPlacement('work_eligibility');
          break;
        case 'step_availability':
          var availLayout = block.sectionLayout || 'stacked';
          var availGridClass = 'nv-wiz-availability-grid';
          if (availLayout === 'side_by_side') availGridClass += ' nv-wiz-availability-grid--side-by-side';
          html += '<div class="' + availGridClass + '">';
          var sbsCardStyle = '';
          if (availLayout === 'side_by_side') {
            var sbsParts = [];
            if (block.sbsBorderColor || block.sbsBorderWidth) {
              sbsParts.push('border: ' + (block.sbsBorderWidth || 1) + 'px solid ' + (block.sbsBorderColor || '#d1d5db'));
            }
            if (block.sbsPadding) sbsParts.push('padding: ' + block.sbsPadding + 'px');
            if (block.sbsRadius) sbsParts.push('border-radius: ' + block.sbsRadius + 'px');
            if (block.sbsBgColor) sbsParts.push('background: ' + block.sbsBgColor);
            if (block.sbsShadow && block.sbsShadow !== 'none') sbsParts.push('box-shadow: ' + block.sbsShadow);
            sbsParts.push('transition: border-color 0.2s ease, box-shadow 0.2s ease');
            sbsCardStyle = ' style="' + sbsParts.join('; ') + '"';
          }
          var sbsHoverData = '';
          if (availLayout === 'side_by_side') {
            sbsHoverData = ' data-sbs-hover-border="' + escapeHtml(block.sbsHoverBorderColor || '') + '" data-sbs-hover-shadow="' + escapeHtml(block.sbsHoverShadow || '') + '" data-sbs-default-border="' + escapeHtml(block.sbsBorderColor || '#d1d5db') + '" data-sbs-default-shadow="' + escapeHtml(block.sbsShadow && block.sbsShadow !== 'none' ? block.sbsShadow : '') + '"';
          }
          if (block.showDaysAvailable) {
            html += '<div class="nv-wiz-field nv-wiz-field--full nv-wiz-sbs-card" data-field-group="days"' + sbsCardStyle + sbsHoverData + '>';
            html += '<div class="nv-wiz-sbs-card-header"><label class="nv-wiz-label">' + escapeHtml(block.labelDaysAvailable) + renderRequiredIndicator(block.requireDaysAvailable) + '</label>';
            html += '<span class="nv-wiz-field-status nv-wiz-field-status--not-started">' + escapeHtml(config.statusNotStarted || 'Not started') + '</span></div>';
            if (block.requireDaysAvailable) html += '<p style="font-size: 13px; color: var(--wiz-subheading-color); margin-bottom: 10px;">' + escapeHtml(block.daysRequiredHint) + '</p>';
            html += '<div class="nv-wiz-checkbox-group">';
            var daysList = (block.daysList || 'Monday\nTuesday\nWednesday\nThursday\nFriday\nSaturday\nSunday\nFlexible / Any').split('\n').map(function(s) { return s.trim(); }).filter(function(s) { return s.length > 0; });
            daysList.forEach(function(day) {
              var dayKey = day.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
              html += '<label class="nv-wiz-checkbox-item"><input type="checkbox" name="contact[days_' + dayKey + ']" value="' + escapeHtml(day) + '" data-day="' + dayKey + '"><span>' + escapeHtml(day) + '</span></label>';
            });
            html += '</div></div>';
          }
          if (block.showShiftPreference) {
            html += '<div class="nv-wiz-field nv-wiz-field--full nv-wiz-sbs-card" data-field-group="shifts"' + sbsCardStyle + sbsHoverData + '>';
            html += '<div class="nv-wiz-sbs-card-header"><label class="nv-wiz-label">' + escapeHtml(block.labelShiftPreference) + renderRequiredIndicator(block.requireShiftPreference) + '</label>';
            html += '<span class="nv-wiz-field-status nv-wiz-field-status--not-started">' + escapeHtml(config.statusNotStarted || 'Not started') + '</span></div>';
            if (block.requireShiftPreference) html += '<p style="font-size: 13px; color: var(--wiz-subheading-color); margin-bottom: 10px;">' + escapeHtml(block.shiftsRequiredHint) + '</p>';
            html += '<div class="nv-wiz-checkbox-group">';
            var shiftsList = (block.shiftsList || 'Day Shift\nEvening Shift\nNight Shift\nFlexible / Any').split('\n').map(function(s) { return s.trim(); }).filter(function(s) { return s.length > 0; });
            shiftsList.forEach(function(shift) {
              var shiftKey = shift.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
              html += '<label class="nv-wiz-checkbox-item"><input type="checkbox" name="contact[shift_' + shiftKey + ']" value="' + escapeHtml(shift) + '" data-shift="' + shiftKey + '"><span>' + escapeHtml(shift) + '</span></label>';
            });
            html += '</div></div>';
          }
          html += '</div>';
          html += renderConditionalFieldsForPlacement('availability');
          break;
        case 'step_experience':
          if (block.showSkills) {
            html += '<div class="nv-wiz-field nv-wiz-field--full"><label class="nv-wiz-label">' + escapeHtml(block.labelSkills) + '</label>';
            html += '<div class="nv-wiz-checkbox-group">';
            var skillsText = block.skillsList || 'General commercial cleaning\nDeep cleaning\nFloor waxing/buffing\nCarpet cleaning\nUse of cleaning machinery\nPost-construction cleaning\nIndustrial/healthcare facility\nValid driver\'s license';
            var skills = skillsText.split('\n').map(function(s) { return s.trim(); }).filter(function(s) { return s.length > 0; });
            skills.forEach(function(skill) {
              var skillId = skill.toLowerCase().replace(/[^a-z0-9]/g, '_');
              html += '<label class="nv-wiz-checkbox-item"><input type="checkbox" name="contact[skill_' + skillId + ']" value="' + escapeHtml(skill) + '" data-skill="' + skillId + '"><span>' + escapeHtml(skill) + '</span></label>';
            });
            html += '</div></div>';
          }
          if (block.showOtherSkills) {
            html += '<div class="nv-wiz-field nv-wiz-field--full"><label class="nv-wiz-label">' + escapeHtml(block.labelOtherSkills) + '</label>';
            html += '<textarea name="contact[body]" class="nv-wiz-textarea" placeholder="' + escapeHtml(block.placeholderOtherSkills) + '" data-field="other_skills"></textarea></div>';
          }
          if (block.showPreviousEmployer) {
            maxEmployers = block.maxEmployers || 3;
            var showFirstEmployer = block.showFirstEmployer !== false;
            html += '<div class="nv-wiz-field nv-wiz-field--full" data-work-history-wrapper data-show-first="' + (showFirstEmployer ? 'true' : 'false') + '">';
            html += '<div style="margin-top: 24px; padding-top: 24px; border-top: 1px solid var(--wiz-input-border);">';
            html += '<h4 style="font-size: 16px; font-weight: 600; color: var(--wiz-heading-color); margin: 0 0 4px;">Work History</h4>';
            html += '<p style="font-size: 13px; color: var(--wiz-subheading-color); margin: 0 0 16px;">Please list your previous employers, starting with the most recent.</p>';
            if (showFirstEmployer) {
              html += '<div data-employers-list>' + renderEmployerCard(1, block) + '</div>';
            } else {
              html += '<div data-employers-list></div>';
            }
            if (block.allowMultipleEmployers || !showFirstEmployer) {
              var addBtnText = showFirstEmployer ? 'Add Another Employer' : 'Add Employer';
              var addEmpFontSize = (block && block.addEmployerFontSize) || 14;
              html += '<button type="button" class="nv-wiz-add-employer" data-add-employer data-add-text-first="Add Employer" data-add-text-another="Add Another Employer" style="font-size:' + addEmpFontSize + 'px;"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 5v14M5 12h14"></path></svg><span>' + addBtnText + '</span></button>';
            }
            html += '</div></div>';
          }
          if (block.showReferences) {
            maxReferences = block.maxReferences || 3;
            var showFirstReference = block.showFirstReference !== false;
            html += '<div class="nv-wiz-references-wrapper nv-wiz-field--full" data-references-wrapper data-show-first="' + (showFirstReference ? 'true' : 'false') + '">';
            html += '<div class="nv-wiz-references-header"><h4 class="nv-wiz-references-title">References' + renderRequiredIndicator(block.requireReferences) + '</h4></div>';
            html += '<p class="nv-wiz-references-help">Please provide contact information for people who can speak to your work ethic and character.</p>';
            if (showFirstReference) {
              html += '<div data-references-list>' + renderReferenceCard(1, block) + '</div>';
            } else {
              html += '<div data-references-list></div>';
            }
            var refAddBtnText = showFirstReference ? 'Add Another Reference' : 'Add Reference';
            var addRefFontSize = (block && block.addReferenceFontSize) || 14;
            html += '<button type="button" class="nv-wiz-add-reference" data-add-reference data-add-text-first="Add Reference" data-add-text-another="Add Another Reference" style="font-size:' + addRefFontSize + 'px;"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 5v14M5 12h14"></path></svg><span>' + refAddBtnText + '</span></button>';
            html += '</div>';
          }
          if (block.showResumeUpload) {
            html += '<div class="nv-wiz-resume-wrapper nv-wiz-field--full" data-resume-wrapper>';
            html += '<label class="nv-wiz-resume-label">' + escapeHtml(block.labelResume || 'Resume (Optional)') + renderRequiredIndicator(block.requireResume) + '</label>';
            html += '<div class="nv-wiz-resume-dropzone" data-resume-dropzone>';
            html += '<div class="nv-wiz-resume-upload-ui"><div class="nv-wiz-resume-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"></path></svg></div>';
            html += '<p class="nv-wiz-resume-text">Drag and drop your resume here</p><p class="nv-wiz-resume-hint">or click to browse</p></div>';
            html += '<div class="nv-wiz-resume-preview"><div class="nv-wiz-resume-file-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline></svg></div>';
            html += '<div class="nv-wiz-resume-file-info"><p class="nv-wiz-resume-filename"></p><p class="nv-wiz-resume-filesize"></p></div>';
            html += '<button type="button" class="nv-wiz-resume-remove" data-resume-remove><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"></path></svg></button></div></div>';
            html += '<input type="file" class="nv-wiz-resume-input" data-resume-input accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">';
            html += '<div class="nv-wiz-resume-error" data-resume-error></div>';
            html += '<p style="font-size: 12px; color: var(--wiz-subheading-color); margin: 8px 0 0;">' + escapeHtml(block.resumeHelpText || 'PDF, DOC, DOCX accepted (max 5MB)') + '</p>';
            if (enableWebhook) {
              html += '<div class="nv-wiz-resume-note"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path></svg><span>Resume files are delivered via webhook. Ensure webhook is enabled for file delivery.</span></div>';
            }
            html += '</div>';
          }
          html += renderConditionalFieldsForPlacement('experience');
          break;
        case 'step_custom_fields':
          for (var i = 1; i <= 4; i++) {
            var fieldType = block['field' + i + 'Type'];
            var fieldLabel = block['field' + i + 'Label'];
            if (fieldType && fieldType !== 'none' && fieldLabel) {
              var fieldPlaceholder = block['field' + i + 'Placeholder'] || '';
              var fieldRequired = block['field' + i + 'Required'];
              var fieldOptions = block['field' + i + 'Options'];
              var optionsArray = fieldOptions ? fieldOptions.split(',').map(function(s) { return s.trim(); }) : [];
              html += renderField(fieldType, 'custom_' + block.id + '_' + i, fieldLabel, fieldPlaceholder, fieldRequired, optionsArray);
            }
          }
          break;
        case 'step_review':
          html += '<div id="nv-wiz-review-content-' + sectionId + '"></div>';
          html += '<div data-reassurance-position="above_declaration"></div>';
          html += '<div class="nv-wiz-declaration nv-wiz-declaration--centered">';
          html += '<p class="nv-wiz-declaration-text">' + escapeHtml(block.declarationText) + '</p>';
          html += '<div class="nv-wiz-declaration-check">';
          html += '<input type="checkbox" id="nv-wiz-declaration-' + sectionId + '" name="contact[declaration]" value="Agreed" required>';
          html += '<label for="nv-wiz-declaration-' + sectionId + '">' + escapeHtml(block.declarationCheckbox) + '</label>';
          html += '</div></div>';
          html += '<div data-reassurance-position="below_declaration"></div>';
          html += '<div data-reassurance-position="above_submit"></div>';
          break;
      }
      html += '</div>';
      return html;
    }
    
    function renderGroupedStep(step, stepIndex) {
      var stepDisplayName = step.name;
      if (stepDisplayName.match(/^Step \d+$/)) stepDisplayName = 'Your Information';
      var html = '<div class="nv-wiz-step" data-step-index="' + stepIndex + '" data-step-name="' + escapeHtml(stepDisplayName) + '">';
      var layoutMode = section.dataset.groupedLayout || 'stacked';
      var wrapperClass = 'nv-wiz-sections-wrapper';
      if (layoutMode === 'two_column') wrapperClass += ' nv-wiz-sections-wrapper--two-column'; if (config.twoColStretch) wrapperClass += ' nv-wiz-sections-wrapper--stretch';
      html += '<div class="' + wrapperClass + '">';
      step.blocks.forEach(function(block, blockIndex) {
        var globalCollapseAll = config.globalCollapseAll;
        var isOpen;
        if (globalCollapseAll === 'expanded') isOpen = true;
        else if (globalCollapseAll === 'collapsed') isOpen = blockIndex === 0;
        else if (globalCollapseAll === 'collapsed_first2') isOpen = blockIndex <= 1;
        else isOpen = !block.collapsedDefault || blockIndex === 0;
        var blockClasses = 'nv-wiz-section-group' + (isOpen ? ' is-open' : '') + (block.forceSingleColumn ? ' nv-wiz-section-group--force-single' : '') + (block.sectionLayout === 'side_by_side' ? ' nv-wiz-section-group--sbs' : '');
        var innerGridAttr = block.innerGridColumns && block.innerGridColumns !== 'auto' ? ' data-inner-grid="' + block.innerGridColumns + '"' : '';
        html += '<div class="' + blockClasses + '" data-block-id="' + block.id + '" data-block-type="' + block.type + '"' + innerGridAttr + '>';
        html += '<div class="nv-wiz-section-header"><div class="nv-wiz-section-header-left">';
        html += '<div class="nv-wiz-section-icon">' + getSectionIcon(block.sectionIcon || 'file') + '</div>';
        html += '<h4 class="nv-wiz-section-title">' + escapeHtml(block.sectionTitle || block.stepTitle || 'Section') + '</h4>';
        html += '</div><div class="nv-wiz-section-status">';
        html += '<span class="nv-wiz-section-complete"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg> <span data-complete-text>Complete</span></span>';
        html += '<span class="nv-wiz-section-incomplete"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg> <span data-incomplete-text>Incomplete</span></span>';
        html += '<span class="nv-wiz-section-progress" data-section-progress></span>';
        html += '<span class="nv-wiz-section-not-started"><span data-not-started-text>' + escapeHtml(config.statusNotStarted || 'Not started') + '</span></span>';
        html += '<svg class="nv-wiz-section-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"></polyline></svg>';
        html += '</div></div>';
        html += '<div class="nv-wiz-section-content">' + renderBlockContent(block) + '</div></div>';
      });
      html += '</div>';
      html += renderNavButtons(stepIndex);
      html += '</div>';
      return html;
    }
    
    function renderSingleStep(step, stepIndex) {
      var block = step.blocks[0];
      var html = '<div class="nv-wiz-step" data-step-index="' + stepIndex + '" data-step-name="' + escapeHtml(step.name) + '" data-block-type="' + block.type + '">';
      if (block.stepTitle) html += '<h3 class="nv-wiz-step-title">' + escapeHtml(block.stepTitle) + '</h3>';
      if (block.stepDesc) html += '<p class="nv-wiz-step-desc">' + escapeHtml(block.stepDesc) + '</p>';
      html += renderBlockContent(block);
      html += renderNavButtons(stepIndex);
      html += '</div>';
      return html;
    }
    
    function renderNavButtons(stepIndex) {
      var isFirst = stepIndex === 0;
      var isReview = wizardSteps[stepIndex].isReview;
      var html = '<div class="nv-wiz-nav">';
      if (!isFirst) html += '<button type="button" class="nv-wiz-btn nv-wiz-btn--secondary" data-action="prev">' + escapeHtml(config.buttonLabels.back) + '</button>';
      if (isReview) html += '<button type="submit" class="nv-wiz-btn nv-wiz-btn--primary">' + escapeHtml(config.buttonLabels.submit) + '</button>';
      else html += '<button type="button" class="nv-wiz-btn nv-wiz-btn--primary" data-action="next">' + escapeHtml(config.buttonLabels.next) + '</button>';
      html += '</div>';
      return html;
    }
    
    function renderAllSteps() {
      var html = '';
      wizardSteps.forEach(function(step, index) {
        if (step.isGrouped) html += renderGroupedStep(step, index);
        else html += renderSingleStep(step, index);
      });
      stepsContainer.innerHTML = html;
      injectReassuranceMessages();
    }
    
    function injectReassuranceMessages() {
      if (!reassuranceConfig) return;
      var beforeSubmitFullWidth = reassuranceConfig.beforeSubmitFullWidth;
      if (reassuranceConfig.showBeforeSubmit && reassuranceConfig.beforeSubmitPosition === 'above_declaration') {
        var aboveDecl = stepsContainer.querySelector('[data-reassurance-position="above_declaration"]');
        if (aboveDecl) {
          aboveDecl.innerHTML = renderReassuranceMessage(reassuranceConfig.beforeSubmitText || 'No commitment - we\'ll reach out if there\'s a good fit', reassuranceConfig.beforeSubmitIcon, reassuranceConfig.beforeSubmitStyle || reassuranceConfig.messageStyle, reassuranceConfig.beforeSubmitColor || reassuranceConfig.textColor, reassuranceConfig.iconColor, reassuranceConfig.bgColor, reassuranceConfig.borderColor, reassuranceConfig.fontSize, reassuranceConfig.beforeSubmitMarginTop, reassuranceConfig.beforeSubmitMarginBottom, reassuranceConfig.beforeSubmitPaddingX, reassuranceConfig.beforeSubmitPaddingY, reassuranceConfig.beforeSubmitNudge, beforeSubmitFullWidth);
        }
      }
      if (reassuranceConfig.showBeforeSubmit && reassuranceConfig.beforeSubmitPosition === 'above_submit') {
        var aboveSubmit = stepsContainer.querySelector('[data-reassurance-position="above_submit"]');
        if (aboveSubmit) {
          aboveSubmit.innerHTML = renderReassuranceMessage(reassuranceConfig.beforeSubmitText || 'No commitment - we\'ll reach out if there\'s a good fit', reassuranceConfig.beforeSubmitIcon, reassuranceConfig.beforeSubmitStyle || reassuranceConfig.messageStyle, reassuranceConfig.beforeSubmitColor || reassuranceConfig.textColor, reassuranceConfig.iconColor, reassuranceConfig.bgColor, reassuranceConfig.borderColor, reassuranceConfig.fontSize, reassuranceConfig.beforeSubmitMarginTop, reassuranceConfig.beforeSubmitMarginBottom, reassuranceConfig.beforeSubmitPaddingX, reassuranceConfig.beforeSubmitPaddingY, reassuranceConfig.beforeSubmitNudge, beforeSubmitFullWidth);
        }
      }
      if (reassuranceConfig.showBeforeSubmit && reassuranceConfig.beforeSubmitPosition === 'below_declaration') {
        var belowDecl = stepsContainer.querySelector('[data-reassurance-position="below_declaration"]');
        if (belowDecl) {
          belowDecl.innerHTML = renderReassuranceMessage(reassuranceConfig.beforeSubmitText || 'No commitment - we\'ll reach out if there\'s a good fit', reassuranceConfig.beforeSubmitIcon, reassuranceConfig.beforeSubmitStyle || reassuranceConfig.messageStyle, reassuranceConfig.beforeSubmitColor || reassuranceConfig.textColor, reassuranceConfig.iconColor, reassuranceConfig.bgColor, reassuranceConfig.borderColor, reassuranceConfig.fontSize, reassuranceConfig.beforeSubmitMarginTop, reassuranceConfig.beforeSubmitMarginBottom, reassuranceConfig.beforeSubmitPaddingX, reassuranceConfig.beforeSubmitPaddingY, reassuranceConfig.beforeSubmitNudge, beforeSubmitFullWidth);
        }
      }
      if (reassuranceConfig.showAfterDeclaration) {
        var afterDeclTarget = stepsContainer.querySelector('[data-reassurance-position="below_declaration"]');
        if (afterDeclTarget && (!reassuranceConfig.showBeforeSubmit || reassuranceConfig.beforeSubmitPosition !== 'below_declaration')) {
          afterDeclTarget.innerHTML = renderReassuranceMessage(reassuranceConfig.afterDeclarationText || 'We respect your privacy', reassuranceConfig.afterDeclarationIcon, reassuranceConfig.messageStyle, reassuranceConfig.textColor, reassuranceConfig.iconColor, reassuranceConfig.bgColor, reassuranceConfig.borderColor, reassuranceConfig.fontSize, reassuranceConfig.afterDeclarationMarginTop, reassuranceConfig.afterDeclarationMarginBottom, reassuranceConfig.afterDeclarationPaddingX, reassuranceConfig.afterDeclarationPaddingY, reassuranceConfig.afterDeclarationNudge, false);
        }
      }
    }
    
    // =============================================
    // NAVIGATION
    // =============================================
    
    var isInitialLoad = true;

    function goToStep(index) {
      if (index < 0 || index >= wizardSteps.length) return;
      var previousIndex = currentStepIndex;
      currentStepIndex = index;
      stepsContainer.querySelectorAll('.nv-wiz-step').forEach(function(stepEl, i) {
        stepEl.classList.toggle('is-active', i === index);
      });
      var stepNum = index + 1;
      if (progressText) progressText.textContent = 'Step ' + stepNum + ' of ' + wizardSteps.length;
      var displayName = getStepDisplayName(index);
      if (stepNameEl) stepNameEl.textContent = displayName;
      if (progressFill) progressFill.style.width = ((stepNum / wizardSteps.length) * 100) + '%';
      updateStepDots(index, previousIndex);
      if (wizardSteps[index].isReview) {
        buildReviewContent();
        isEditingFromReview = false;
      }
      hideFormAlert();
      saveProgress();
      if (!isInitialLoad) {
        var formWrapper = section.querySelector('.nv-wiz-form-wrapper');
        if (formWrapper) {
          var headerOffset = 100;
          var elementPosition = formWrapper.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({ top: elementPosition - headerOffset, behavior: 'smooth' });
        }
      }
      isInitialLoad = false;
    }
    
    function markStepCompleted(stepIndex) {
      if (completedSteps.has(stepIndex)) return;
      completedSteps.add(stepIndex);
      if (dotsContainer && stepNavConfig) {
        var wrapper = dotsContainer.querySelector('[data-step-index="' + stepIndex + '"]');
        if (wrapper) {
          var dot = wrapper.querySelector('.nv-wiz-dot');
          var ripple = dot ? dot.querySelector('.nv-wiz-dot-ripple') : null;
          if (stepNavConfig.enablePopAnimation && dot) {
            dot.classList.add('is-completing');
            setTimeout(function() { dot.classList.remove('is-completing'); }, 400);
          }
          if (stepNavConfig.enableRipple && ripple) {
            ripple.classList.add('is-animating');
            setTimeout(function() { ripple.classList.remove('is-animating'); }, 600);
          }
        }
      }
      updateStepDots(currentStepIndex, currentStepIndex);
    }
    
    // =============================================
    // STEP NAVIGATION DOTS
    // =============================================

    function canNavigateToStep(targetIndex) {
      if (targetIndex === currentStepIndex) return false;
      if (completedSteps.has(targetIndex)) return true;
      if (targetIndex < currentStepIndex) return true;
      // Allow forward jump if all steps before target are completed
      for (var s = 0; s < targetIndex; s++) {
        if (!completedSteps.has(s)) return false;
      }
      return true;
    }
    
    function buildStepDots() {
      if (!dotsContainer || !stepNavConfig || !stepNavConfig.enableDots) return;
      var html = '';
      var numPos = stepNavConfig.numberPosition;
      var wrapperClass = 'nv-wiz-dot-wrapper';
      if (numPos === 'above') wrapperClass += ' nv-wiz-dot-wrapper--numbers-above';
      if (numPos === 'below') wrapperClass += ' nv-wiz-dot-wrapper--numbers-below';
      wizardSteps.forEach(function(step, i) {
        var stepNum = i + 1;
        var stateClass = i === 0 ? 'is-current' : '';
        var tooltipName = step.name;
        if (tooltipName.match(/^Step \d+$/)) {
          if (step.isReview) tooltipName = 'Review & Submit';
          else if (step.isGrouped) tooltipName = 'Your Information';
          else if (step.blocks && step.blocks.length > 0) {
            var firstBlock = step.blocks[0];
            tooltipName = firstBlock.sectionTitle || firstBlock.stepTitle || ('Step ' + stepNum);
          }
        }
        html += '<div class="' + wrapperClass + ' ' + stateClass + '" data-step-index="' + i + '" data-step-name="' + escapeHtml(tooltipName) + '">';
        if (numPos === 'above' || numPos === 'below') html += '<span class="nv-wiz-dot-number nv-wiz-dot-number--external">' + stepNum + '</span>';
        html += '<div class="nv-wiz-dot" role="button" tabindex="-1" aria-label="Step ' + stepNum + ': ' + escapeHtml(tooltipName) + '">';
        html += '<span class="nv-wiz-dot-ripple"></span>';
        if (numPos === 'inside') html += '<span class="nv-wiz-dot-number nv-wiz-dot-number--inside">' + stepNum + '</span>';
        html += '</div>';
        if (stepNavConfig.showTooltip) html += '<div class="nv-wiz-dot-tooltip">Step ' + stepNum + ': ' + escapeHtml(tooltipName) + '</div>';
        html += '</div>';
      });
      dotsContainer.innerHTML = html;
      dotsContainer.querySelectorAll('.nv-wiz-dot-wrapper').forEach(function(wrapper) {
        var dot = wrapper.querySelector('.nv-wiz-dot');
        wrapper.addEventListener('click', function() {
          var targetIndex = parseInt(wrapper.dataset.stepIndex, 10);
          if (targetIndex === currentStepIndex) return;
          if (canNavigateToStep(targetIndex)) {
            if (wizardSteps[currentStepIndex].isReview) isEditingFromReview = true;
            goToStep(targetIndex);
          } else if (targetIndex === currentStepIndex + 1) {
            // Clicking one step ahead: validate current step first (like Next button)
            if (validateStep(currentStepIndex)) {
              markStepCompleted(currentStepIndex);
              goToStep(targetIndex);
            }
          }
        });
        if (dot) {
          dot.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              wrapper.click();
            }
          });
        }
      });
    }
    
    function updateStepDots(newIndex, previousIndex) {
      if (!dotsContainer || !stepNavConfig || !stepNavConfig.enableDots) return;
      var wrappers = dotsContainer.querySelectorAll('.nv-wiz-dot-wrapper');
      wrappers.forEach(function(wrapper, i) {
        var dot = wrapper.querySelector('.nv-wiz-dot');
        var isCompleted = completedSteps.has(i);
        var isCurrent = i === newIndex;
        wrapper.classList.remove('is-completed', 'is-current', 'is-upcoming', 'is-navigable');
        var isNavigable = canNavigateToStep(i) || i === currentStepIndex + 1;
        if (isCurrent) {
          wrapper.classList.add('is-current');
          dot.setAttribute('tabindex', '-1');
          dot.style.cursor = 'default';
          dot.setAttribute('aria-current', 'step');
        } else if (isCompleted) {
          wrapper.classList.add('is-completed');
          dot.setAttribute('tabindex', '0');
          dot.style.cursor = 'pointer';
          dot.removeAttribute('aria-current');
        } else if (isNavigable) {
          wrapper.classList.add('is-navigable');
          dot.setAttribute('tabindex', '0');
          dot.style.cursor = 'pointer';
          dot.removeAttribute('aria-current');
        } else {
          wrapper.classList.add('is-upcoming');
          dot.setAttribute('tabindex', '-1');
          dot.style.cursor = 'default';
          dot.removeAttribute('aria-current');
        }
        updateDotContent(wrapper, i, isCompleted, isCurrent);
      });
      updateTrackFill(newIndex);
    }
    
    function updateDotContent(wrapper, index, isCompleted, isCurrent) {
      var dot = wrapper.querySelector('.nv-wiz-dot');
      var stepNum = index + 1;
      var indicator = stepNavConfig.completedIndicator;
      var numPos = stepNavConfig.numberPosition;
      var existingBadge = wrapper.querySelector('.nv-wiz-dot-check-badge');
      if (existingBadge) existingBadge.remove();
      if (isCompleted && !isCurrent) {
        if (indicator === 'checkmark') {
          dot.innerHTML = '<span class="nv-wiz-dot-ripple"></span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><polyline points="20 6 9 17 4 12"></polyline></svg>';
        } else if (indicator === 'both') {
          if (numPos === 'inside') dot.innerHTML = '<span class="nv-wiz-dot-ripple"></span><span class="nv-wiz-dot-number nv-wiz-dot-number--inside">' + stepNum + '</span>';
          else dot.innerHTML = '<span class="nv-wiz-dot-ripple"></span>';
          var badge = document.createElement('div');
          badge.className = 'nv-wiz-dot-check-badge';
          badge.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>';
          wrapper.appendChild(badge);
        } else {
          if (numPos === 'inside') dot.innerHTML = '<span class="nv-wiz-dot-ripple"></span><span class="nv-wiz-dot-number nv-wiz-dot-number--inside">' + stepNum + '</span>';
          else dot.innerHTML = '<span class="nv-wiz-dot-ripple"></span>';
        }
      } else {
        if (numPos === 'inside') dot.innerHTML = '<span class="nv-wiz-dot-ripple"></span><span class="nv-wiz-dot-number nv-wiz-dot-number--inside">' + stepNum + '</span>';
        else dot.innerHTML = '<span class="nv-wiz-dot-ripple"></span>';
      }
    }
    
    function updateTrackFill(currentIndex) {
      if (!lineFill || !stepNavConfig || !stepNavConfig.showTrack) return;
      var highestCompleted = -1;
      completedSteps.forEach(function(idx) { if (idx > highestCompleted) highestCompleted = idx; });
      var fillToIndex = Math.max(highestCompleted, currentIndex - 1);
      if (fillToIndex < 0 || wizardSteps.length <= 1) lineFill.style.width = '0%';
      else {
        var segmentPercent = 100 / (wizardSteps.length - 1);
        var fillPercent = segmentPercent * fillToIndex;
        lineFill.style.width = Math.min(fillPercent, 100) + '%';
      }
    }
    
    // =============================================
    // VALIDATION
    // =============================================
    
    function validateStep(stepIndex) {
      var stepEl = stepsContainer.querySelector('[data-step-index="' + stepIndex + '"]');
      if (!stepEl) return true;
      var isValid = true;
      var errors = [];
      var errorFields = [];
      stepEl.querySelectorAll('[required]').forEach(function(field) {
        clearFieldError(field);
        if (field.type === 'radio') {
          var radioGroup = stepEl.querySelectorAll('[name="' + field.name + '"]');
          var anyChecked = Array.from(radioGroup).some(function(r) { return r.checked; });
          if (!anyChecked) {
            isValid = false;
            var label = getFieldLabel(field);
            errors.push(label + ' is required');
            errorFields.push('[name="' + field.name + '"]');
          }
        } else if (!field.value.trim()) {
          isValid = false;
          showFieldError(field, 'This field is required');
          var label = getFieldLabel(field);
          errors.push(label + ' is required');
          errorFields.push('[name="' + field.name + '"]');
        }
      });
      stepEl.querySelectorAll('.nv-wiz-conditional-field[data-visibility-state="visible"]').forEach(function(fieldWrapper) {
        var fieldId = fieldWrapper.dataset.conditionalFieldId;
        var fieldConfig = conditionalFields.find(function(f) { return f.id === fieldId; });
        if (!fieldConfig || !fieldConfig.requiredWhenVisible) return;
        var fieldType = fieldConfig.fieldType;
        var hasValue = false;
        if (fieldType === 'checkbox') {
          var checkboxes = fieldWrapper.querySelectorAll('input[type="checkbox"]');
          hasValue = Array.from(checkboxes).some(function(cb) { return cb.checked; });
        } else if (fieldType === 'radio') {
          var radios = fieldWrapper.querySelectorAll('input[type="radio"]');
          hasValue = Array.from(radios).some(function(r) { return r.checked; });
        } else {
          var input = fieldWrapper.querySelector('input, select, textarea');
          hasValue = input && input.value && input.value.trim();
        }
        if (!hasValue) {
          isValid = false;
          fieldWrapper.classList.add('has-error');
          var label = fieldConfig.fieldLabel || 'Field';
          errors.push(label + ' is required');
          errorFields.push('[data-conditional-field-id="' + fieldId + '"]');
        } else { fieldWrapper.classList.remove('has-error'); }
      });
      stepEl.querySelectorAll('[type="email"]').forEach(function(emailField) {
        if (emailField.value.trim() && !validateEmail(emailField.value.trim())) {
          isValid = false;
          showFieldError(emailField, 'Please enter a valid email address');
          errors.push('Please enter a valid email address');
          errorFields.push('[name="' + emailField.name + '"]');
        }
      });
      stepEl.querySelectorAll('[type="tel"]').forEach(function(phoneField) {
        if (phoneField.value.trim() && !validatePhone(phoneField.value.trim())) {
          isValid = false;
          showFieldError(phoneField, 'Please enter a valid phone number');
          errors.push('Please enter a valid phone number');
          errorFields.push('[name="' + phoneField.name + '"]');
        }
      });
      var daysGroup = stepEl.querySelector('[data-field-group="days"]');
      if (daysGroup) {
        var step = wizardSteps[stepIndex];
        var availBlock = step.blocks.find(function(b) { return b.type === 'step_availability'; });
        if (availBlock && availBlock.requireDaysAvailable) {
          var anyDayChecked = stepEl.querySelectorAll('[data-day]:checked').length > 0;
          if (!anyDayChecked) {
            isValid = false;
            daysGroup.classList.add('has-error');
            errors.push('Please select at least one day you are available to work');
            errorFields.push('[data-field-group="days"]');
          } else { daysGroup.classList.remove('has-error'); }
        }
      }
      var shiftsGroup = stepEl.querySelector('[data-field-group="shifts"]');
      if (shiftsGroup) {
        var step = wizardSteps[stepIndex];
        var availBlock = step.blocks.find(function(b) { return b.type === 'step_availability'; });
        if (availBlock && availBlock.requireShiftPreference) {
          var anyShiftChecked = stepEl.querySelectorAll('[data-shift]:checked').length > 0;
          if (!anyShiftChecked) {
            isValid = false;
            shiftsGroup.classList.add('has-error');
            errors.push('Please select at least one preferred shift');
            errorFields.push('[data-field-group="shifts"]');
          } else { shiftsGroup.classList.remove('has-error'); }
        }
      }
      if (wizardSteps[stepIndex].isGrouped) {
        stepEl.querySelectorAll('.nv-wiz-section-group').forEach(function(group) {
          var groupResult = validateSectionGroup(group);
          if (!groupResult.valid) {
            isValid = false;
            errors = errors.concat(groupResult.errors);
            errorFields = errorFields.concat(groupResult.errorFields);
          }
        });
      }
      var stepBlocks = wizardSteps[stepIndex].blocks || [wizardSteps[stepIndex]];
      var hasAboutYou = stepBlocks.some(function(b) { return b.type === 'step_about_you'; });
      if (hasAboutYou) {
        var ageResult = validateAgeVerification();
        if (!ageResult.valid) {
          isValid = false;
          errors.push(ageResult.message);
          errorFields.push('[data-dob-field]');
        }
      }
      if (errors.length > 0) {
        var uniqueErrors = [];
        var uniqueFields = [];
        var seen = {};
        errors.forEach(function(err, i) {
          if (!seen[err]) {
            seen[err] = true;
            uniqueErrors.push(err);
            uniqueFields.push(errorFields[i]);
          }
        });
        showFormAlert(uniqueErrors, true, uniqueFields);
      }
      return isValid;
    }
    
    function validateSectionGroup(groupEl) {
      var isValid = true;
      var errors = [];
      var errorFields = [];
      groupEl.querySelectorAll('[required]').forEach(function(field) {
        clearFieldError(field);
        if (field.type === 'radio') {
          var radioGroup = groupEl.querySelectorAll('[name="' + field.name + '"]');
          var anyChecked = Array.from(radioGroup).some(function(r) { return r.checked; });
          if (!anyChecked) {
            isValid = false;
            var label = getFieldLabel(field);
            errors.push(label + ' is required');
            errorFields.push('[name="' + field.name + '"]');
          }
        } else if (!field.value.trim()) {
          isValid = false;
          showFieldError(field, 'This field is required');
          var label = getFieldLabel(field);
          errors.push(label + ' is required');
          errorFields.push('[name="' + field.name + '"]');
        }
      });
      updateSectionCompleteStatus(groupEl, isValid);
      return { valid: isValid, errors: errors, errorFields: errorFields };
    }
    
    function updateSectionCompleteStatus(groupEl, forceValid) {
      var isValid = forceValid;
      if (typeof isValid === 'undefined') {
        isValid = true;
        var requiredFields = groupEl.querySelectorAll('[required]');
        requiredFields.forEach(function(field) {
          if (field.type === 'radio') {
            var radioGroup = groupEl.querySelectorAll('[name="' + field.name + '"]');
            var anyChecked = Array.from(radioGroup).some(function(r) { return r.checked; });
            if (!anyChecked) isValid = false;
          } else if (!field.value.trim()) isValid = false;
        });
        var daysGroup = groupEl.querySelector('[data-field-group="days"]');
        if (daysGroup) {
          var anyDayChecked = groupEl.querySelectorAll('[data-day]:checked').length > 0;
          var hint = daysGroup.querySelector('p');
          if (hint && hint.textContent.toLowerCase().includes('select at least') && !anyDayChecked) isValid = false;
        }
        var shiftsGroup = groupEl
        .querySelector('[data-field-group="shifts"]');
        if (shiftsGroup) {
          var anyShiftChecked = groupEl.querySelectorAll('[data-shift]:checked').length > 0;
          var hint = shiftsGroup.querySelector('p');
          if (hint && hint.textContent.toLowerCase().includes('select at least') && !anyShiftChecked) isValid = false;
        }
      }
      var hasAnyValue = false;
      var totalFields = 0;
      var filledFields = 0;
      var checkedNames = {};
      groupEl.querySelectorAll('input, select, textarea').forEach(function(field) {
        if (field.type === 'hidden' || field.type === 'submit') return;
        if (field.type === 'checkbox' || field.type === 'radio') {
          var name = field.name;
          if (checkedNames[name]) return;
          checkedNames[name] = true;
          totalFields++;
          var anyChecked = !!groupEl.querySelector('input[name="' + name + '"]:checked');
          if (anyChecked) { filledFields++; hasAnyValue = true; }
        } else {
          totalFields++;
          if (field.value && field.value.trim()) { filledFields++; hasAnyValue = true; }
        }
      });
      groupEl.classList.remove('is-complete', 'is-incomplete', 'is-not-started');
      if (isValid && hasAnyValue) groupEl.classList.add('is-complete');
      else if (hasAnyValue && !isValid) groupEl.classList.add('is-incomplete');
      else groupEl.classList.add('is-not-started');
      // Update progress counter
      var progressEl = groupEl.querySelector('[data-section-progress]');
      if (progressEl && config.showSectionProgress) {
        if (hasAnyValue && totalFields > 0) {
          progressEl.textContent = filledFields + ' of ' + totalFields;
          progressEl.style.display = 'inline-block';
        } else {
          progressEl.style.display = 'none';
        }
      } else if (progressEl) {
        progressEl.style.display = 'none';
      }
    }

    // =============================================
    // REVIEW CONTENT
    // =============================================

    function updateFieldGroupStatus(fieldGroup) {
      if (!fieldGroup) return;
      var statusEl = fieldGroup.querySelector('.nv-wiz-field-status');
      if (!statusEl) return;
      var checkboxes = fieldGroup.querySelectorAll('input[type="checkbox"]');
      var anyChecked = Array.from(checkboxes).some(function(cb) { return cb.checked; });
      var allChecked = checkboxes.length > 0 && Array.from(checkboxes).every(function(cb) { return cb.checked; });
      statusEl.classList.remove('nv-wiz-field-status--not-started', 'nv-wiz-field-status--in-progress', 'nv-wiz-field-status--complete');
      if (!anyChecked) {
        statusEl.classList.add('nv-wiz-field-status--not-started');
        statusEl.textContent = config.statusNotStarted || 'Not started';
      } else if (allChecked) {
        statusEl.classList.add('nv-wiz-field-status--complete');
        statusEl.textContent = config.statusFieldComplete || 'All selected';
      } else {
        statusEl.classList.add('nv-wiz-field-status--in-progress');
        var checkedCount = Array.from(checkboxes).filter(function(cb) { return cb.checked; }).length;
        statusEl.textContent = checkedCount + ' of ' + checkboxes.length + ' selected';
      }
    }

    function initSbsCardHovers() {
      var cards = section.querySelectorAll('.nv-wiz-sbs-card[data-sbs-hover-border]');
      cards.forEach(function(card) {
        var hoverBorder = card.dataset.sbsHoverBorder;
        var hoverShadow = card.dataset.sbsHoverShadow;
        var defaultBorder = card.dataset.sbsDefaultBorder;
        var defaultShadow = card.dataset.sbsDefaultShadow;
        card.addEventListener('mouseenter', function() {
          if (hoverBorder) card.style.borderColor = hoverBorder;
          if (hoverShadow) card.style.boxShadow = hoverShadow;
        });
        card.addEventListener('mouseleave', function() {
          card.style.borderColor = defaultBorder || '';
          card.style.boxShadow = defaultShadow || '';
        });
      });
    }

    function getStatusBadgeHtml(requiredCount, optionalCount) {
      if (requiredCount > 0) {
        var text = requiredCount === 1 ? config.statusRequiredSingular : config.statusRequiredPlural;
        return '<span class="nv-wiz-review-section-status nv-wiz-review-section-status--required"><span class="nv-wiz-status-count">(' + requiredCount + ')</span> ' + escapeHtml(text) + '</span>';
      } else if (optionalCount > 0) {
        var text = optionalCount === 1 ? config.statusOptionalSingular : config.statusOptionalPlural;
        return '<span class="nv-wiz-review-section-status nv-wiz-review-section-status--optional"><span class="nv-wiz-status-count">(' + optionalCount + ')</span> ' + escapeHtml(text) + '</span>';
      } else {
        return '<span class="nv-wiz-review-section-status nv-wiz-review-section-status--complete">' + escapeHtml(config.statusComplete || 'Complete') + '</span>';
      }
    }

    function countFieldStatus(container) {
      var result = { required: 0, optional: 0 };
      if (!container) return result;
      var fields = container.querySelectorAll('input, select, textarea');
      var checkedNames = {};
      fields.forEach(function(field) {
        if (field.type === 'hidden' || field.type === 'submit') return;
        var hasValue = false;
        if (field.type === 'checkbox' || field.type === 'radio') {
          var name = field.name;
          if (checkedNames[name]) return;
          var checked = container.querySelector('input[name="' + name + '"]:checked');
          hasValue = !!checked;
          checkedNames[name] = true;
        } else { hasValue = field.value && field.value.trim(); }
        if (!hasValue) {
          if (field.hasAttribute('required')) result.required++;
          else result.optional++;
        }
      });
      return result;
    }
function formatCalDate(val) {
      if (!val || val === 'Present') return val || '';
      var parts = val.split('-');
      if (parts.length === 3) {
        var mNames = ['January','February','March','April','May','June','July','August','September','October','November','December'];
        var m = parseInt(parts[1], 10) - 1;
        return mNames[m] + ' ' + parseInt(parts[2], 10) + ', ' + parts[0];
      }
      return val;
    }
    function buildReviewContent() {
      var reviewContainer = section.querySelector('#nv-wiz-review-content-' + sectionId);
      if (!reviewContainer) return;
      var reviewBlock = config.blocks.find(function(b) { return b.type === 'step_review'; });
      var reviewLayout = reviewBlock && reviewBlock.reviewLayout || 'stacked';
      var html = '';
      var stepMapping = buildStepMapping();
      var blockMapping = buildBlockMapping();

      // Role
      var roleField = form.querySelector('[name="contact[role]"]');
      if (roleField && roleField.value) {
        var roleItems = [{ label: 'Role', value: roleField.value }];
        var licenseField = form.querySelector('[name="contact[drivers_license]"]');
        if (licenseField && licenseField.value && licenseField.value.trim()) roleItems.push({ label: "Driver's License", value: licenseField.value });
        var cleaningExpField = form.querySelector('[name="contact[cleaning_experience]"]');
        if (cleaningExpField && cleaningExpField.value && cleaningExpField.value.trim()) roleItems.push({ label: 'Cleaning Experience', value: cleaningExpField.value });
        var machineryExpField = form.querySelector('[name="contact[machinery_experience]"]');
        if (machineryExpField && machineryExpField.value && machineryExpField.value.trim()) roleItems.push({ label: 'Machinery Experience', value: machineryExpField.value });
        html += buildReviewSection('Position', roleItems, stepMapping.role, blockMapping.role);
      }

      // About You
      var aboutYou = [];
      addReviewItem(aboutYou, 'First Name', '[name="contact[first_name]"]');
      addReviewItem(aboutYou, 'Last Name', '[name="contact[last_name]"]');
      addReviewItem(aboutYou, 'Date of Birth', '[name="contact[date_of_birth]"]');
      addReviewItem(aboutYou, 'Phone', '[name="contact[phone]"]');
      addReviewItem(aboutYou, 'Email', '[name="contact[email]"]');
      var aboutContainer = stepsContainer.querySelector('[data-block-type="step_about_you"]');
      var aboutStatus = aboutContainer ? countFieldStatus(aboutContainer) : { required: 0, optional: 0 };
      if (aboutYou.length > 0) html += buildReviewSectionWithStatus('About You', aboutYou, stepMapping.aboutYou, blockMapping.aboutYou, aboutStatus);

      // Address
      var address = [];
      addReviewItem(address, 'Mailing Address', '[name="contact[mailing_address]"]');
      addReviewItem(address, 'Residential Address', '[name="contact[residential_address]"]');
      addReviewItem(address, 'Community', '[name="contact[community]"]');
      addReviewItem(address, 'Postal Code', '[name="contact[postal_code]"]');
      if (address.length > 0) {
        var addressContainer = stepsContainer.querySelector('[data-block-type="step_address"]');
        var addressStatus = addressContainer ? countFieldStatus(addressContainer) : { required: 0, optional: 0 };
        html += buildReviewSectionWithStatus('Address', address, stepMapping.address, blockMapping.address, addressStatus);
      }

      // Emergency Contact
      var emergency = [];
      var hasEmergencyBlock = config.blocks.some(function(b) { return b.type === 'step_emergency_contact'; });
      var emergencyContainer = stepsContainer.querySelector('[data-block-type="step_emergency_contact"]');
      if (emergencyContainer) {
        var ecCards = emergencyContainer.querySelectorAll('.nv-wiz-emergency-card');
        if (ecCards.length > 0) {
          ecCards.forEach(function(card) {
            var idx = card.dataset.emergencyIndex;
            var prefix = 'Emergency Contact ' + idx;
            addReviewItem(emergency, (ecCards.length > 1 ? prefix + ' - ' : '') + 'Contact Name', '[name="contact[emergency_' + idx + '_name]"]');
            addReviewItem(emergency, (ecCards.length > 1 ? prefix + ' - ' : '') + 'Contact Phone', '[name="contact[emergency_' + idx + '_phone]"]');
            addReviewItem(emergency, (ecCards.length > 1 ? prefix + ' - ' : '') + 'Relationship', '[name="contact[emergency_' + idx + '_relationship]"]');
          });
        } else {
          addReviewItem(emergency, 'Contact Name', '[name="contact[emergency_1_name]"]');
          addReviewItem(emergency, 'Contact Phone', '[name="contact[emergency_1_phone]"]');
          addReviewItem(emergency, 'Relationship', '[name="contact[emergency_1_relationship]"]');
        }
      }
      var emergencyStatus = emergencyContainer ? countFieldStatus(emergencyContainer) : { required: 0, optional: 0 };
      if (emergency.length > 0) html += buildReviewSectionWithStatus('Emergency Contact', emergency, stepMapping.emergency, blockMapping.emergency, emergencyStatus);
      else if (hasEmergencyBlock) html += buildReviewSectionWithStatus('Emergency Contact', [{ label: 'Status', value: 'Not provided' }], stepMapping.emergency, blockMapping.emergency, emergencyStatus);

      // Work Eligibility
      var eligibility = [];
      var workEligible = form.querySelector('[name="contact[work_eligible]"]:checked');
      if (workEligible) eligibility.push({ label: 'Eligible to Work', value: workEligible.value });
      addReviewItem(eligibility, 'NTI Number', '[name="contact[nti_number]"]');
      if (eligibility.length > 0) {
        var eligibilityContainer = stepsContainer.querySelector('[data-block-type="step_work_eligibility"]');
        var eligibilityStatus = eligibilityContainer ? countFieldStatus(eligibilityContainer) : { required: 0, optional: 0 };
        html += buildReviewSectionWithStatus('Work Eligibility', eligibility, stepMapping.eligibility, blockMapping.eligibility, eligibilityStatus);
      }

      // Availability
      var availability = [];
      var days = [];
      form.querySelectorAll('[data-day]:checked').forEach(function(cb) { days.push(cb.value); });
      if (days.length > 0) availability.push({ label: 'Days Available', value: days.join(', ') });
      var shifts = [];
      form.querySelectorAll('[data-shift]:checked').forEach(function(cb) { shifts.push(cb.value); });
      if (shifts.length > 0) availability.push({ label: 'Preferred Shifts', value: shifts.join(', ') });
      var hasAvailabilityBlock = config.blocks.some(function(b) { return b.type === 'step_availability'; });
      var availabilityContainer = stepsContainer.querySelector('[data-block-type="step_availability"]');
      var availabilityStatus = availabilityContainer ? countFieldStatus(availabilityContainer) : { required: 0, optional: 0 };
      if (availability.length > 0) html += buildReviewSectionWithStatus('Availability', availability, stepMapping.availability, blockMapping.availability, availabilityStatus);
      else if (hasAvailabilityBlock) html += buildReviewSectionWithStatus('Availability', [{ label: 'Status', value: 'Not provided' }], stepMapping.availability, blockMapping.availability, availabilityStatus);

      // Experience & Skills
      var experience = [];
      var skills = [];
      form.querySelectorAll('[data-skill]:checked').forEach(function(cb) { skills.push(cb.value); });
      if (skills.length > 0) experience.push({ label: 'Skills', value: skills.join(', ') });
      addReviewItem(experience, 'Other Skills/Notes', '[name="contact[body]"]');
      for (var emp = 1; emp <= 10; emp++) {
        var empNameField = form.querySelector('[name="contact[employer_' + emp + '_name]"]');
        if (!empNameField) continue;
        var empName = empNameField.value ? empNameField.value.trim() : '';
        if (empName) {
          var empPosition = getFieldValue('[name="contact[employer_' + emp + '_position]"]');
          var empReason = getFieldValue('[name="contact[employer_' + emp + '_reason]"]');
          var empFromRaw = getFieldValue('[name="contact[employer_' + emp + '_from]"]');
          var empFrom = formatCalDate(empFromRaw);
          var presentCheckbox = form.querySelector('[name="contact[employer_' + emp + '_present]"]');
          var isPresent = presentCheckbox && presentCheckbox.checked;
          var empTo = 'Present';
          if (!isPresent) {
            var empToRaw = getFieldValue('[name="contact[employer_' + emp + '_to]"]');
            empTo = empToRaw === 'Present' ? 'Present' : formatCalDate(empToRaw);
          }
          var empString = empName;
          if (empPosition) empString += ' - ' + empPosition;
          if (empFrom || empTo) empString += ' (' + (empFrom || '?') + ' to ' + (empTo || '?') + ')';
          if (empReason) empString += ' [Left: ' + empReason + ']';
          experience.push({ label: 'Employer ' + emp, value: empString });
          var mayContact = form.querySelector('[name="contact[employer_' + emp + '_contact]"]:checked');
          if (mayContact) experience.push({ label: 'May Contact Employer ' + emp, value: mayContact.value });
        }
      }
      for (var ref = 1; ref <= 10; ref++) {
        var refNameField = form.querySelector('[name="contact[reference_' + ref + '_name]"]');
        if (!refNameField) continue;
        var refName = refNameField.value ? refNameField.value.trim() : '';
        if (refName) {
          var refRel = getFieldValue('[name="contact[reference_' + ref + '_relationship]"]');
          var refPhone = getFieldValue('[name="contact[reference_' + ref + '_phone]"]');
          var refString = refName;
          if (refRel) refString += ' (' + refRel + ')';
          if (refPhone) refString += ' - ' + refPhone;
          experience.push({ label: 'Reference ' + ref, value: refString });
        }
      }
      if (resumeFileData && resumeFileData.filename) experience.push({ label: 'Resume', value: resumeFileData.filename + ' (' + formatFileSize(resumeFileData.size) + ')' });
      var hasExperienceBlock = config.blocks.some(function(b) { return b.type === 'step_experience'; });
      var experienceContainer = stepsContainer.querySelector('[data-block-type="step_experience"]');
      var experienceStatus = experienceContainer ? countFieldStatus(experienceContainer) : { required: 0, optional: 0 };
      if (experience.length > 0) html += buildReviewSectionWithStatus('Experience & Skills', experience, stepMapping.experience, blockMapping.experience, experienceStatus);
      else if (hasExperienceBlock) html += buildReviewSectionWithStatus('Experience & Skills', [{ label: 'Status', value: 'No experience information provided' }], stepMapping.experience, blockMapping.experience, experienceStatus);

      var wrapperClass = 'nv-wiz-review-wrapper';
      if (reviewLayout === 'two_column') wrapperClass += ' nv-wiz-review-wrapper--two-column';
      if (reviewLayout === 'three_column') wrapperClass += ' nv-wiz-review-wrapper--three-column';
      if (reviewBlock && reviewBlock.reviewFillGaps) wrapperClass += ' nv-wiz-review-wrapper--fill-gaps';
      if (reviewBlock && reviewBlock.reviewCardEnabled) wrapperClass += ' nv-wiz-review-wrapper--cards';
      if (reviewBlock && reviewBlock.reviewDividers === false) wrapperClass += ' nv-wiz-review-wrapper--no-dividers';
      reviewContainer.innerHTML = '<div class="' + wrapperClass + '">' + html + '</div>';

      // Attach edit button handlers
      reviewContainer.querySelectorAll('[data-edit-step]').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          var targetStep = parseInt(btn.dataset.editStep, 10);
          var targetBlockId = btn.dataset.editBlock || null;
          if (!isNaN(targetStep) && targetStep >= 0 && targetStep < wizardSteps.length) {
            isEditingFromReview = true;
            goToStep(targetStep);
            setTimeout(function() {
              var targetGroup = null;
              if (targetBlockId) targetGroup = stepsContainer.querySelector('[data-block-id="' + targetBlockId + '"]');
              if (!targetGroup && targetBlockId) {
                config.blocks.forEach(function(block) {
                  if (block.id === targetBlockId) {
                    targetGroup = stepsContainer.querySelector('[data-block-type="' + block.type + '"]');
                  }
                });
              }
              if (targetGroup) {
                var stepEl = stepsContainer.querySelector('.nv-wiz-step.is-active');
                if (stepEl) stepEl.querySelectorAll('.nv-wiz-section-group').forEach(function(g) { g.classList.remove('is-open'); });
                targetGroup.classList.add('is-open');
                setTimeout(function() {
                  var scrollOffset = parseInt(section.dataset.scrollOffset || '120', 10);
                  scrollToElement(targetGroup, scrollOffset);
                }, 50);
              } else {
                var stepEl = stepsContainer.querySelector('.nv-wiz-step.is-active');
                if (stepEl) scrollToElement(stepEl, 120);
              }
            }, 200);
          }
        });
      });
    }

    function getFieldValue(selector) {
      var field = form.querySelector(selector);
      return field && field.value ? field.value.trim() : '';
    }

    function buildStepMapping() {
      var mapping = { role: 0, aboutYou: 1, address: 1, emergency: 1, eligibility: 1, availability: 1, experience: 1 };
      wizardSteps.forEach(function(step, stepIndex) {
        if (step.blocks) {
          step.blocks.forEach(function(block) {
            switch(block.type) {
              case 'step_role_selection': mapping.role = stepIndex; break;
              case 'step_about_you': mapping.aboutYou = stepIndex; break;
              case 'step_address': mapping.address = stepIndex; break;
              case 'step_emergency_contact': mapping.emergency = stepIndex; break;
              case 'step_work_eligibility': mapping.eligibility = stepIndex; break;
              case 'step_availability': mapping.availability = stepIndex; break;
              case 'step_experience': mapping.experience = stepIndex; break;
            }
          });
        }
      });
      return mapping;
    }

    function buildBlockMapping() {
      var mapping = { role: null, aboutYou: null, address: null, emergency: null, eligibility: null, availability: null, experience: null };
      config.blocks.forEach(function(block) {
        switch(block.type) {
          case 'step_role_selection': mapping.role = block.id; break;
          case 'step_about_you': mapping.aboutYou = block.id; break;
          case 'step_address': mapping.address = block.id; break;
          case 'step_emergency_contact': mapping.emergency = block.id; break;
          case 'step_work_eligibility': mapping.eligibility = block.id; break;
          case 'step_availability': mapping.availability = block.id; break;
          case 'step_experience': mapping.experience = block.id; break;
        }
      });
      return mapping;
    }

    function addReviewItem(arr, label, selector) {
      var field = form.querySelector(selector);
      if (field && field.value && field.value.trim()) arr.push({ label: label, value: field.value });
    }

    function buildReviewSectionWithStatus(title, items, editStepIndex, editBlockId, status) {
      var html = '<div class="nv-wiz-review-section">';
      html += '<div class="nv-wiz-review-header-with-status"><div class="nv-wiz-review-header-left">';
      html += '<div class="nv-wiz-review-title">' + escapeHtml(title) + '</div>';
      html += '</div><div class="nv-wiz-review-header-right">';
      if (status) html += getStatusBadgeHtml(status.required, status.optional);
      html += '<button type="button" class="nv-wiz-review-edit" data-edit-step="' + editStepIndex + '"' + (editBlockId ? ' data-edit-block="' + editBlockId + '"' : '') + '><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg> Edit</button>';
      html += '</div></div><div class="nv-wiz-review-grid">';
      items.forEach(function(item) {
        html += '<div class="nv-wiz-review-item"><span class="nv-wiz-review-label">' + escapeHtml(item.label) + '</span><span class="nv-wiz-review-value">' + escapeHtml(item.value) + '</span></div>';
      });
      html += '</div></div>';
      return html;
    }

    function buildReviewSection(title, items, editStepIndex, editBlockId) {
      var html = '<div class="nv-wiz-review-section"><div class="nv-wiz-review-header">';
      html += '<div class="nv-wiz-review-title">' + escapeHtml(title) + '</div>';
      html += '<button type="button" class="nv-wiz-review-edit" data-edit-step="' + editStepIndex + '"' + (editBlockId ? ' data-edit-block="' + editBlockId + '"' : '') + '><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg> Edit</button>';
      html += '</div><div class="nv-wiz-review-grid">';
      items.forEach(function(item) {
        html += '<div class="nv-wiz-review-item"><span class="nv-wiz-review-label">' + escapeHtml(item.label) + '</span><span class="nv-wiz-review-value">' + escapeHtml(item.value) + '</span></div>';
      });
      html += '</div></div>';
      return html;
    }
    // =============================================
    // EVENT HANDLERS
    // =============================================

    function initEventHandlers() {
      stepsContainer.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-action]');
        if (!btn) return;
        var action = btn.dataset.action;
        if (action === 'next') {
          if (validateStep(currentStepIndex)) {
            markStepCompleted(currentStepIndex);
            goToStep(currentStepIndex + 1);
          }
        } else if (action === 'prev') { goToStep(currentStepIndex - 1); }
      });
      stepsContainer.addEventListener('click', function(e) {
        var header = e.target.closest('.nv-wiz-section-header');
        if (!header) return;
        var group = header.closest('.nv-wiz-section-group');
        if (group) group.classList.toggle('is-open');
      });
      stepsContainer.addEventListener('click', function(e) {
        var addBtn = e.target.closest('[data-add-employer]');
        if (addBtn) {
          var wrapper = addBtn.closest('[data-work-history-wrapper]');
          var block = null;
          config.blocks.forEach(function(b) { if (b.type === 'step_experience') block = b; });
          if (wrapper) addEmployer(wrapper, block);
        }
      });
      stepsContainer.addEventListener('click', function(e) {
        var removeBtn = e.target.closest('[data-remove-employer]');
        if (removeBtn) {
          var wrapper = removeBtn.closest('[data-work-history-wrapper]');
          var index = parseInt(removeBtn.dataset.removeEmployer, 10);
          if (wrapper) {
            var card = wrapper.querySelector('[data-employer-index="' + index + '"]');
            if (card && cardHasData(card)) showConfirmDialog('employer', wrapper, index, 'This employer entry contains information that will be permanently lost.');
            else removeEmployer(wrapper, index);
          }
        }
      });
      stepsContainer.addEventListener('click', function(e) {
        var addECBtn = e.target.closest('[data-add-emergency]');
        if (addECBtn) {
          var wrapper = addECBtn.closest('[data-emergency-contacts-wrapper]');
          var block = null;
          config.blocks.forEach(function(b) { if (b.type === 'step_emergency_contact') block = b; });
          if (wrapper) addEmergencyContact(wrapper, block);
        }
      });
      stepsContainer.addEventListener('click', function(e) {
        var removeECBtn = e.target.closest('[data-remove-emergency]');
        if (removeECBtn) {
          var wrapper = removeECBtn.closest('[data-emergency-contacts-wrapper]');
          var index = parseInt(removeECBtn.dataset.removeEmergency, 10);
          if (wrapper && index > 1) {
            var card = wrapper.querySelector('[data-emergency-index="' + index + '"]');
            if (card && cardHasData(card)) showConfirmDialog('emergency', wrapper, index, 'This emergency contact entry contains information that will be permanently lost.');
            else removeEmergencyContact(wrapper, index);
          }
        }
      });
      stepsContainer.addEventListener('click', function(e) {
        var addBtn = e.target.closest('[data-add-reference]');
        if (addBtn) {
          var wrapper = addBtn.closest('[data-references-wrapper]');
          var block = null;
          config.blocks.forEach(function(b) { if (b.type === 'step_experience') block = b; });
          if (wrapper) addReference(wrapper, block);
        }
      });
      stepsContainer.addEventListener('click', function(e) {
        var removeBtn = e.target.closest('[data-remove-reference]');
        if (removeBtn) {
          var wrapper = removeBtn.closest('[data-references-wrapper]');
          var index = parseInt(removeBtn.dataset.removeReference, 10);
          if (wrapper) {
            var card = wrapper.querySelector('[data-reference-index="' + index + '"]');
            if (card && cardHasData(card)) showConfirmDialog('reference', wrapper, index, 'This reference entry contains information that will be permanently lost.');
            else removeReference(wrapper, index);
          }
        }
      });
      form.addEventListener('change', function(e) {
        if (e.target.type === 'checkbox') {
          updateCheckboxVisual(e.target);
          saveProgress();
          var fieldGroup = e.target.closest('[data-field-group]');
          if (fieldGroup && fieldGroup.classList.contains('has-error')) {
            var anyChecked = fieldGroup.querySelectorAll('input:checked').length > 0;
            if (anyChecked) showGroupSuccess(fieldGroup);
          }
          if (fieldGroup) updateFieldGroupStatus(fieldGroup);
        } else if (e.target.type === 'radio') {
          updateRadioVisual(e.target);
          saveProgress();
          var fieldGroup = e.target.closest('[data-field-group]');
          if (fieldGroup && fieldGroup.classList.contains('has-error')) showGroupSuccess(fieldGroup);
          var radioWrapper = e.target.closest('.nv-wiz-field');
          if (radioWrapper && radioWrapper.classList.contains('has-error')) {
            radioWrapper.classList.remove('has-error');
            showFieldSuccess(radioWrapper);
          }
          var condFieldWrapper = e.target.closest('.nv-wiz-conditional-field');
          if (condFieldWrapper && condFieldWrapper.classList.contains('has-error')) {
            condFieldWrapper.classList.remove('has-error');
            showGroupSuccess(condFieldWrapper);
          }
        } else {
          saveProgress();
          var condFieldWrapper = e.target.closest('.nv-wiz-conditional-field');
          if (condFieldWrapper && condFieldWrapper.classList.contains('has-error')) {
            if (e.target.value && e.target.value.trim()) {
              condFieldWrapper.classList.remove('has-error');
              showGroupSuccess(condFieldWrapper);
            }
          }
        }
        if (e.target.name === 'contact[role]') {
          updateRoleTether(e.target.value);
          updateConditionalFieldsVisibility(e.target.value);
        }
        var sectionGroup = e.target.closest('.nv-wiz-section-group');
        if (sectionGroup) updateSectionCompleteStatus(sectionGroup);
      });
      var completeStatusTimeout = null;
      form.addEventListener('input', function(e) {
        var sectionGroup = e.target.closest('.nv-wiz-section-group');
        if (sectionGroup) {
          if (completeStatusTimeout) clearTimeout(completeStatusTimeout);
          completeStatusTimeout = setTimeout(function() { updateSectionCompleteStatus(sectionGroup); }, 150);
        }
      });
      form.addEventListener('focusout', function(e) {
        var sectionGroup = e.target.closest('.nv-wiz-section-group');
        if (sectionGroup) updateSectionCompleteStatus(sectionGroup);
      });
      form.addEventListener('input', function(e) {
        if (e.target.type === 'tel') formatPhone(e.target);
      });
      if (formAlert) {
        formAlert.addEventListener('click', function(e) {
          var link = e.target.closest('.nv-wiz-error-link');
          if (!link) return;
          e.preventDefault();
          e.stopPropagation();
          var fieldSelector = link.dataset.errorField;
          var errorIndex = parseInt(link.dataset.errorIndex, 10);
          if (fieldSelector) {
            scrollToAndFocusField(fieldSelector);
            currentErrorIndex = errorIndex;
          }
        });
      }
      form.addEventListener('input', function(e) {
        if (e.target.matches('.nv-wiz-input, .nv-wiz-select, .nv-wiz-textarea')) clearFieldError(e.target);
      });
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var declaration = form.querySelector('#nv-wiz-declaration-' + sectionId);
        if (!declaration || !declaration.checked) {
          showFormAlert(['Please agree to the declaration before submitting.'], true);
          return;
        }
        var allValid = true;
        for (var i = 0; i < wizardSteps.length - 1; i++) {
          if (!validateStep(i)) { allValid = false; goToStep(i); break; }
        }
        if (!allValid) return;
        var submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Submitting...'; }
        if (enableTestMode) { setTimeout(function() { showSuccessState(); }, 1000); return; }
        if (enableWebhook && webhookUrl) {
          sendWebhook().then(function() {
            if (enableShopify) submitShopifyForm();
            else showSuccessState();
          }).catch(function() {
            if (enableShopify) submitShopifyForm();
            else showSuccessState();
          });
        } else if (enableShopify) { submitShopifyForm(); }
        else { showSuccessState(); }
      });
    }

    // =============================================
    // AGE VERIFICATION
    // =============================================
    var ageVerificationState = { needsConsent: false, isBlocked: false, currentAge: null, mode: 'eligibility' };

    function initAgeVerification() {
      var aboutBlock = config.blocks.find(function(b) { return b.type === 'step_about_you'; });
      if (!aboutBlock || !aboutBlock.enableAgeVerification) return;

      var ageMode = aboutBlock.ageVerificationMode || 'eligibility';
      ageVerificationState.mode = ageMode;

      var ageMessageEl = stepsContainer.querySelector('[data-age-message]');
      var guardianConsentEl = stepsContainer.querySelector('[data-guardian-consent]');

      function getMinAgeForRole() {
        var minAge = aboutBlock.minAgeNoConsent || 16;
        if (!aboutBlock.enableRoleAgeRules) return minAge;
        var roleField = form.querySelector('[name="contact[role]"]');
        var selectedRole = roleField ? roleField.value : null;
        if (!selectedRole || !aboutBlock.roleAgeRules) return minAge;
        var rules = aboutBlock.roleAgeRules.split('\n');
        for (var i = 0; i < rules.length; i++) {
          var parts = rules[i].split(':');
          if (parts.length === 2) {
            var roleName = parts[0].trim();
            var roleMinAge = parseInt(parts[1].trim(), 10);
            if (selectedRole.toLowerCase() === roleName.toLowerCase() && !isNaN(roleMinAge)) {
              return roleMinAge;
            }
          }
        }
        return minAge;
      }

      function showAgeBlocked(minAge) {
        if (ageMessageEl) {
          var msg = (aboutBlock.ageBlockedMessage || "We're sorry, applicants must be at least [age] years old to apply for this position.").replace('[age]', minAge);
          ageMessageEl.innerHTML = '<div class="nv-wiz-age-blocked"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><path d="M15 9l-6 6M9 9l6 6"></path></svg><span>' + escapeHtml(msg) + '</span></div>';
          ageMessageEl.style.display = 'block';
        }
        if (guardianConsentEl) {
          guardianConsentEl.style.display = 'none';
          setGuardianFieldsRequired(false);
        }
      }

      function showAgeConsent(minAge) {
        var youngAge = aboutBlock.youngPersonAge || 17;
        if (ageMessageEl) {
          var msg = (aboutBlock.ageConsentMessage || 'Applicants under [age] require parental or guardian consent to apply.').replace('[age]', youngAge);
          ageMessageEl.innerHTML = '<div class="nv-wiz-age-consent"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path></svg><span>' + escapeHtml(msg) + '</span></div>';
          ageMessageEl.style.display = 'block';
        }
        if (guardianConsentEl) {
          guardianConsentEl.style.display = 'block';
          setGuardianFieldsRequired(true);
        }
      }

      function hideAgeMessages() {
        if (ageMessageEl) {
          ageMessageEl.style.display = 'none';
          ageMessageEl.innerHTML = '';
        }
        if (guardianConsentEl) {
          guardianConsentEl.style.display = 'none';
          setGuardianFieldsRequired(false);
        }
      }

      function setGuardianFieldsRequired(required) {
        if (!guardianConsentEl) return;
        var fields = guardianConsentEl.querySelectorAll('[data-guardian-field]');
        fields.forEach(function(field) {
          if (required) field.setAttribute('required', '');
          else field.removeAttribute('required');
        });
      }

      if (ageMode === 'date_of_birth') {
        var dobField = form.querySelector('[data-dob-field]');
        if (!dobField) return;

        function calculateAge(birthDate) {
          var today = new Date();
          var birth = new Date(birthDate);
          var age = today.getFullYear() - birth.getFullYear();
          var monthDiff = today.getMonth() - birth.getMonth();
          if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) age--;
          return age;
        }

        function updateAgeVerificationDOB() {
          var dobValue = dobField.value;
          if (!dobValue) {
            hideAgeMessages();
            ageVerificationState.isBlocked = false;
            ageVerificationState.needsConsent = false;
            return;
          }
          var age = calculateAge(dobValue);
          ageVerificationState.currentAge = age;
          var minAge = getMinAgeForRole();
          var hardMinAge = aboutBlock.hardMinAge || 14;

          if (age < hardMinAge) {
            ageVerificationState.isBlocked = true;
            ageVerificationState.needsConsent = false;
            showAgeBlocked(hardMinAge);
          } else if (age < minAge) {
            ageVerificationState.isBlocked = false;
            ageVerificationState.needsConsent = true;
            showAgeConsent(minAge);
          } else {
            ageVerificationState.isBlocked = false;
            ageVerificationState.needsConsent = false;
            hideAgeMessages();
          }
        }

        dobField.addEventListener('change', updateAgeVerificationDOB);
        dobField.addEventListener('blur', updateAgeVerificationDOB);

        var roleField = form.querySelector('[name="contact[role]"]');
        if (roleField && aboutBlock.enableRoleAgeRules) {
          roleField.addEventListener('change', function() {
            if (dobField.value) updateAgeVerificationDOB();
          });
        }
        if (dobField.value) updateAgeVerificationDOB();

      } else {
        var showEligQ = aboutBlock.showAgeEligibilityQuestion !== false;
        var showUnderQ = aboutBlock.showAgeUnderQuestion !== false;
        var ageEligibleRadios = form.querySelectorAll('[data-age-eligible]');
        var ageUnderRadios = form.querySelectorAll('[data-age-under]');
        var ageUnderField = stepsContainer.querySelector('[data-age-under-field]');
        var minAge = getMinAgeForRole();

        function updateAgeVerificationEligibility() {
          if (!showEligQ && !showUnderQ) {
            ageVerificationState.isBlocked = false;
            ageVerificationState.needsConsent = false;
            return;
          }

          if (!showEligQ && showUnderQ) {
            var underValue = null;
            ageUnderRadios.forEach(function(r) { if (r.checked) underValue = r.value; });
            if (underValue === 'Yes') {
              ageVerificationState.needsConsent = true;
              ageVerificationState.isBlocked = false;
              showAgeConsent(minAge);
            } else if (underValue === 'No') {
              ageVerificationState.needsConsent = false;
              ageVerificationState.isBlocked = false;
              hideAgeMessages();
            }
            return;
          }

          var eligibleValue = null;
          ageEligibleRadios.forEach(function(r) { if (r.checked) eligibleValue = r.value; });

          if (eligibleValue === 'No') {
            ageVerificationState.isBlocked = true;
            ageVerificationState.needsConsent = false;
            showAgeBlocked(minAge);
            if (ageUnderField) ageUnderField.style.display = 'none';
            ageUnderRadios.forEach(function(r) { r.removeAttribute('required'); });
          } else if (eligibleValue === 'Yes') {
            ageVerificationState.isBlocked = false;
            if (showUnderQ && ageUnderField) {
              ageUnderField.style.display = 'block';
              ageUnderRadios.forEach(function(r) { r.setAttribute('required', ''); });
              var underValue = null;
              ageUnderRadios.forEach(function(r) { if (r.checked) underValue = r.value; });

              if (underValue === 'Yes') {
                ageVerificationState.needsConsent = true;
                showAgeConsent(minAge);
              } else if (underValue === 'No') {
                ageVerificationState.needsConsent = false;
                hideAgeMessages();
              } else {
                hideAgeMessages();
              }
            } else {
              ageVerificationState.needsConsent = false;
              hideAgeMessages();
            }
          } else {
            ageVerificationState.isBlocked = false;
            ageVerificationState.needsConsent = false;
            hideAgeMessages();
            if (ageUnderField) ageUnderField.style.display = 'none';
          }
        }

        ageEligibleRadios.forEach(function(r) {
          r.addEventListener('change', updateAgeVerificationEligibility);
        });
        ageUnderRadios.forEach(function(r) {
          r.addEventListener('change', updateAgeVerificationEligibility);
        });

        var roleField = form.querySelector('[name="contact[role]"]');
        if (roleField && aboutBlock.enableRoleAgeRules) {
          roleField.addEventListener('change', function() {
            minAge = getMinAgeForRole();
            updateAgeVerificationEligibility();
          });
        }

        updateAgeVerificationEligibility();
      }
    }

    function validateAgeVerification() {
      var aboutBlock = config.blocks.find(function(b) { return b.type === 'step_about_you'; });
      if (!aboutBlock || !aboutBlock.enableAgeVerification) return { valid: true };

      if (ageVerificationState.isBlocked) {
        return { valid: false, message: 'You do not meet the minimum age requirement for this position.' };
      }
      if (ageVerificationState.needsConsent) {
        var guardianConsentEl = stepsContainer.querySelector('[data-guardian-consent]');
        if (!guardianConsentEl) return { valid: true };

        var guardianName = form.querySelector('[name="contact[guardian_name]"]');
        var guardianPhone = form.querySelector('[name="contact[guardian_phone]"]');
        var guardianConsent = form.querySelector('[name="contact[guardian_consent]"]');

        var errors = [];
        if (!guardianName || !guardianName.value.trim()) errors.push('Parent/Guardian name is required');
        if (!guardianPhone || !guardianPhone.value.trim()) errors.push('Parent/Guardian phone is required');

        if (aboutBlock && aboutBlock.consentMode === 'detailed') {
          var guardianRel = form.querySelector('[name="contact[guardian_relationship]"]');
          var guardianEmail = form.querySelector('[name="contact[guardian_email]"]');
          if (!guardianRel || !guardianRel.value) errors.push('Relationship to applicant is required');
          if (!guardianEmail || !guardianEmail.value.trim()) errors.push('Parent/Guardian email is required');
        }

        if (!guardianConsent || !guardianConsent.checked) errors.push('You must confirm parental/guardian consent');

        if (errors.length > 0) return { valid: false, message: errors.join('. ') + '.' };
      }
      return { valid: true };
    }

    function sendWebhook() {
      return new Promise(function(resolve, reject) {
        // Helper to get field value
        function getVal(selector) {
          var el = form.querySelector(selector);
          return el ? el.value.trim() : '';
        }
        function getChecked(selector) {
          var el = form.querySelector(selector);
          return el ? el.checked : false;
        }
        function getRadio(name) {
          var el = form.querySelector('[name="contact[' + name + ']"]:checked');
          return el ? el.value : '';
        }

        // Collect all checked checkboxes matching a pattern into an array
        function collectChecked(pattern) {
          var results = [];
          form.querySelectorAll('input[type="checkbox"]:checked').forEach(function(cb) {
            if (cb.name && cb.name.indexOf(pattern) !== -1) {
              results.push(cb.value);
            }
          });
          return results;
        }

        // Build structured payload
        var payload = {
          _meta: {
            submitted_at: new Date().toISOString(),
            source: window.location.href,
            form_type: 'nv_custom_wizard',
            notification_emails: webhookEmails || ''
          },
          role: getVal('[name="contact[role]"]'),
          applicant: {
            first_name: getVal('[name="contact[first_name]"]'),
            last_name: getVal('[name="contact[last_name]"]'),
            email: getVal('[name="contact[email]"]'),
            phone: getVal('[name="contact[phone]"]'),
            date_of_birth: getVal('[name="contact[date_of_birth]"]'),
            age_eligible: getRadio('age_eligible'),
            age_under_threshold: getRadio('age_under_threshold')
          },
          address: {
            mailing: getVal('[name="contact[mailing_address]"]'),
            residential: getVal('[name="contact[residential_address]"]'),
            community: getVal('[name="contact[community]"]'),
            postal_code: getVal('[name="contact[postal_code]"]')
          },
          guardian: {
            name: getVal('[name="contact[guardian_name]"]'),
            phone: getVal('[name="contact[guardian_phone]"]'),
            relationship: getVal('[name="contact[guardian_relationship]"]'),
            email: getVal('[name="contact[guardian_email]"]'),
            consent: getChecked('[name="contact[guardian_consent]"]') ? 'Yes' : ''
          },
          emergency_contacts: [],
          eligibility: {
            work_eligible: getRadio('work_eligible'),
            nti_number: getVal('[name="contact[nti_number]"]')
          },
          availability: {
            days: collectChecked('days_'),
            shifts: collectChecked('shift_'),
            start_date: getVal('[name="contact[start_date]"]')
          },
          skills: collectChecked('skill_'),
          other_skills: getVal('[name="contact[body]"]'),
          employers: [],
          references: [],
          declaration_agreed: getChecked('[name="contact[declaration]"]'),
          resume: null
        };

        // Collect emergency contacts (up to 5)
        for (var ec = 1; ec <= 5; ec++) {
          var ecName = getVal('[name="contact[emergency_' + ec + '_name]"]');
          if (ecName) {
            payload.emergency_contacts.push({
              name: ecName,
              phone: getVal('[name="contact[emergency_' + ec + '_phone]"]'),
              relationship: getVal('[name="contact[emergency_' + ec + '_relationship]"]')
            });
          }
        }

        // Collect employers (up to 5)
        for (var emp = 1; emp <= 5; emp++) {
          var empName = getVal('[name="contact[employer_' + emp + '_name]"]');
          if (empName) {
            var presentCheckbox = form.querySelector('[name="contact[employer_' + emp + '_present]"]');
            var isPresent = presentCheckbox ? presentCheckbox.checked : false;
            payload.employers.push({
              name: empName,
              position: getVal('[name="contact[employer_' + emp + '_position]"]'),
              reason_for_leaving: getVal('[name="contact[employer_' + emp + '_reason]"]'),
              from_date: getVal('[name="contact[employer_' + emp + '_from]"]'),
              to_date: isPresent ? 'Present' : getVal('[name="contact[employer_' + emp + '_to]"]'),
              currently_employed: isPresent ? 'Yes' : 'No',
              may_contact: getRadio('employer_' + emp + '_contact')
            });
          }
        }

        // Collect references (up to 5)
        for (var ref = 1; ref <= 5; ref++) {
          var refName = getVal('[name="contact[reference_' + ref + '_name]"]');
          if (refName) {
            payload.references.push({
              name: refName,
              relationship: getVal('[name="contact[reference_' + ref + '_relationship]"]'),
              phone: getVal('[name="contact[reference_' + ref + '_phone]"]'),
              email: getVal('[name="contact[reference_' + ref + '_email]"]')
            });
          }
        }

        // Attach resume if present
        if (resumeFileData) {
          payload.resume = {
            filename: resumeFileData.filename,
            content_type: resumeFileData.content_type,
            size: resumeFileData.size,
            data_base64: resumeFileData.data_base64
          };
        }

        // Remove empty guardian object if not used
        if (!payload.guardian.name) {
          payload.guardian = null;
        }

        // Send to webhook
        fetch(webhookUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function(response) {
            if (response.ok) resolve();
            else reject(new Error('Webhook failed: ' + response.status));
          })
          .catch(reject);
      });
    }

    function submitShopifyForm() {
      try { localStorage.setItem(pendingSubmitKey, 'true'); } catch(e) {}
      window.scrollTo({ top: 0, behavior: 'instant' });
      form.submit();
    }

    // =============================================
    // WORK HISTORY
    // =============================================

    function getMonthOptions() {
      return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    }

    function getYearOptions() {
      var currentYear = new Date().getFullYear();
      var years = [];
      for (var y = currentYear; y >= currentYear - 25; y--) years.push(y);
      return years;
    }

    function renderDatePicker(name, placeholder) {
      var isYearOnly = placeholder === 'Year';
      var isMonthOnly = placeholder === 'Month';
      var html = '<div class="nv-wiz-date-picker" data-date-picker="' + name + '" data-picker-type="' + (isYearOnly ? 'year' : 'month') + '">';
      if (isYearOnly) {
        html += '<input type="number" name="contact[' + name + ']" class="nv-wiz-input nv-wiz-year-input" placeholder="' + escapeHtml(placeholder) + '" min="1950" max="' + new Date().getFullYear() + '" data-year-input>';
      } else {
        html += '<div class="nv-wiz-month-select-wrapper">';
        html += '<input type="text" class="nv-wiz-input nv-wiz-month-input" placeholder="' + escapeHtml(placeholder) + '" autocomplete="off" data-month-input>';
        html += '<input type="hidden" name="contact[' + name + ']" data-month-value>';
        html += '<div class="nv-wiz-month-dropdown" data-month-dropdown>';
        getMonthOptions().forEach(function(month) { html += '<div class="nv-wiz-month-option" data-month="' + month + '">' + month + '</div>'; });
        html += '</div></div>';
      }
      html += '</div>';
      return html;
    }
// =============================================
    // CALENDAR DATE PICKER (Year / Month / Day)
    // =============================================
    var calMonthNames = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    var calWeekdays = ['Su','Mo','Tu','We','Th','Fr','Sa'];

    function renderCalendarPicker(name, placeholder, required, maxDate, overrideName, extraAttrs) {
      var inputName = overrideName || ('contact[' + name + ']');
      var html = '<div class="nv-wiz-cal-picker" data-cal-picker="' + name + '"' + (maxDate ? ' data-cal-max="' + maxDate + '"' : '') + '>';
      html += '<button type="button" class="nv-wiz-cal-trigger" data-cal-trigger aria-haspopup="dialog">';
      html += '<span class="nv-wiz-cal-trigger-text is-placeholder">' + escapeHtml(placeholder) + '</span>';
      html += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>';
      html += '</button>';
      html += '<input type="hidden" name="' + inputName + '" data-cal-value data-field="' + name + '"' + (required ? ' required' : '') + (extraAttrs ? ' ' + extraAttrs : '') + '>';
      html += '<div class="nv-wiz-cal-popup" data-cal-popup role="dialog" aria-label="Choose a date">';
      html += '<div class="nv-wiz-cal-header">';
      html += '<button type="button" class="nv-wiz-cal-nav" data-cal-prev aria-label="Previous month"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"></polyline></svg></button>';
      html += '<div class="nv-wiz-cal-selects">';
      html += '<select class="nv-wiz-cal-select nv-wiz-cal-select--month" data-cal-month-select aria-label="Month">';
      calMonthNames.forEach(function(m, i) { html += '<option value="' + i + '">' + m + '</option>'; });
      html += '</select>';
      var curYear = new Date().getFullYear();
      html += '<select class="nv-wiz-cal-select" data-cal-year-select aria-label="Year">';
      for (var y = curYear + 5; y >= curYear - 100; y--) { html += '<option value="' + y + '">' + y + '</option>'; }
      html += '</select>';
      html += '</div>';
      html += '<button type="button" class="nv-wiz-cal-nav" data-cal-next aria-label="Next month"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"></polyline></svg></button>';
      html += '</div>';
      html += '<div class="nv-wiz-cal-weekdays">';
      calWeekdays.forEach(function(wd) { html += '<div class="nv-wiz-cal-weekday">' + wd + '</div>'; });
      html += '</div>';
      html += '<div class="nv-wiz-cal-days" data-cal-days></div>';
      html += '<div class="nv-wiz-cal-footer"><button type="button" class="nv-wiz-cal-today-btn" data-cal-today>Today</button></div>';
      html += '</div></div>';
      return html;
    }
    function renderEmployerCard(index, block) {
      var isRequired = block && block.requirePreviousEmployer;
      var empGrid = block && block.employerInnerGrid ? block.employerInnerGrid : '2';
      var reasonFullWidth = block.employerReasonFullWidth !== false;
      var html = '<div class="nv-wiz-employer-card" data-employer-index="' + index + '" data-inner-grid="' + empGrid + '" data-reason-full-width="' + reasonFullWidth + '">';
      html += '<div class="nv-wiz-employer-header"><h5 class="nv-wiz-employer-title">Employer ' + index + '</h5>';
      html += '<button type="button" class="nv-wiz-employer-remove" data-remove-employer="' + index + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"></path></svg>Remove</button></div>';
      // Get customizable text from block settings
      var nameLabel = (block && block.employerNameLabel) || 'Employer Name';
      var namePlaceholder = (block && block.employerNamePlaceholder) || 'Company name';
      var positionLabel = (block && block.employerPositionLabel) || 'Position / Job Title';
      var positionPlaceholder = (block && block.employerPositionPlaceholder) || 'Your role at this company';
      var reasonLabel = (block && block.employerReasonLabel) || 'Reason for Leaving';
      var reasonPlaceholder = (block && block.employerReasonPlaceholder) || 'e.g. Career growth, relocation, contract ended';
      var fromLabel = (block && block.employerFromLabel) || 'From';
      var toLabel = (block && block.employerToLabel) || 'To';
      var presentLabel = (block && block.employerPresentLabel) || 'Currently employed here';

      html += '<div class="nv-wiz-employer-fields">';
      html += '<div class="nv-wiz-field"><label class="nv-wiz-label">' + nameLabel + (isRequired && index === 1 ? renderRequiredIndicator(true) : '') + '</label>';
      html += '<input type="text" name="contact[employer_' + index + '_name]" class="nv-wiz-input" placeholder="' + namePlaceholder + '" data-field="employer_' + index + '_name"' + (isRequired && index === 1 ? ' required' : '') + '></div>';
      html += '<div class="nv-wiz-field"><label class="nv-wiz-label">' + positionLabel + '</label><input type="text" name="contact[employer_' + index + '_position]" class="nv-wiz-input" placeholder="' + positionPlaceholder + '" data-field="employer_' + index + '_position"></div>';
      html += '<div class="nv-wiz-field" data-field-type="reason"><label class="nv-wiz-label">' + reasonLabel + '</label><input type="text" name="contact[employer_' + index + '_reason]" class="nv-wiz-input" placeholder="' + reasonPlaceholder + '" data-field="employer_' + index + '_reason"></div>';
      html += '<div class="nv-wiz-field"><label class="nv-wiz-label">' + fromLabel + '</label>';
      html += renderCalendarPicker('employer_' + index + '_from', fromLabel);
      html += '</div>';
      html += '<div class="nv-wiz-field"><label class="nv-wiz-label">' + toLabel + '</label>';
      html += '<div data-employer-to-picker="' + index + '">';
      html += renderCalendarPicker('employer_' + index + '_to', toLabel);
      html += '</div>';
      // Badge inline styles from block settings
      var badgeBg = (block && block.presentBadgeBg) || '#f0fdf4';
      var badgeBorder = (block && block.presentBadgeBorder) || '#bbf7d0';
      var badgeText = (block && block.presentBadgeText) || '#166534';
      var badgeCheck = (block && block.presentBadgeCheck) || '#22c55e';
      var badgeStyle = 'background:' + badgeBg + ';border-color:' + badgeBorder + ';';
      var labelStyle = 'color:' + badgeText + ';';
      var checkStyle = 'accent-color:' + badgeCheck + ';';

      html += '<div class="nv-wiz-present-toggle" style="' + badgeStyle + '"><input type="checkbox" id="employer_' + index + '_present" name="contact[employer_' + index + '_present]" value="Currently employed" data-present-toggle="' + index + '" style="' + checkStyle + '">';
      html += '<label for="employer_' + index + '_present" style="' + labelStyle + '">' + presentLabel + '</label></div></div></div>';
      if (block && block.showMayContact) {
        html += '<div class="nv-wiz-may-contact"><span class="nv-wiz-may-contact-label">May we contact this employer?</span>';
        html += '<div class="nv-wiz-radio-group"><label class="nv-wiz-radio-item"><input type="radio" name="contact[employer_' + index + '_contact]" value="Yes"><span>Yes</span></label>';
        html += '<label class="nv-wiz-radio-item"><input type="radio" name="contact[employer_' + index + '_contact]" value="No"><span>No</span></label></div></div>';
      }
      html += '</div>';
      return html;
    }

    function initDatePickers(container) {
      container.querySelectorAll('[data-month-input]').forEach(function(input) {
        var wrapper = input.closest('.nv-wiz-month-select-wrapper');
        var dropdown = wrapper.querySelector('[data-month-dropdown]');
        var hiddenInput = wrapper.querySelector('[data-month-value]');
        var months = getMonthOptions();

        function filterMonths(query) {
          var q = query.toLowerCase();
          dropdown.querySelectorAll('[data-month]').forEach(function(opt) {
            var month = opt.dataset.month.toLowerCase();
            opt.style.display = month.startsWith(q) || q === '' ? 'block' : 'none';
          });
        }

        function selectMonth(month) {
          input.value = month;
          hiddenInput.value = month;
          dropdown.classList.remove('is-open');
          dropdown.querySelectorAll('[data-month]').forEach(function(opt) {
            opt.classList.toggle('is-selected', opt.dataset.month === month);
          });
          saveProgress();
        }

        input.addEventListener('focus', function() {
          filterMonths(input.value);
          dropdown.classList.add('is-open');
        });

        input.addEventListener('input', function() {
          filterMonths(input.value);
          dropdown.classList.add('is-open');
          var q = input.value.toLowerCase();
          var match = months.find(function(m) { return m.toLowerCase().startsWith(q); });
          if (match && q.length > 0) {
            hiddenInput.value = match;
          }
        });

        input.addEventListener('blur', function() {
          setTimeout(function() {
            dropdown.classList.remove('is-open');
            var q = input.value.toLowerCase();
            var match = months.find(function(m) { return m.toLowerCase() === q || m.toLowerCase().startsWith(q); });
            if (match) {
              input.value = match;
              hiddenInput.value = match;
            } else if (input.value) {
              input.value = hiddenInput.value || '';
            }
          }, 150);
        });

        dropdown.addEventListener('click', function(e) {
          var opt = e.target.closest('[data-month]');
          if (opt) selectMonth(opt.dataset.month);
        });
      });

      container.querySelectorAll('[data-year-input]').forEach(function(input) {
        input.addEventListener('change', function() { saveProgress(); });
        input.addEventListener('blur', function() { saveProgress(); });
      });

      document.addEventListener('click', function(e) {
        if (!e.target.closest('.nv-wiz-month-select-wrapper')) {
          document.querySelectorAll('.nv-wiz-month-dropdown.is-open').forEach(function(d) { d.classList.remove('is-open'); });
        }
      });
    }

    function initPresentToggle(container) {
      container.querySelectorAll('[data-present-toggle]').forEach(function(toggle) {
        toggle.addEventListener('change', function() {
          var empIndex = toggle.dataset.presentToggle;
          var card = container.querySelector('[data-employer-index="' + empIndex + '"]');
          if (!card) return;
          var toPickerWrap = card.querySelector('[data-employer-to-picker="' + empIndex + '"]');
          if (!toPickerWrap) return;
          var toTrigger = toPickerWrap.querySelector('[data-cal-trigger]');
          var toHidden = toPickerWrap.querySelector('[data-cal-value]');
          var toText = toPickerWrap.querySelector('.nv-wiz-cal-trigger-text');
          if (toggle.checked) {
            if (toTrigger) toTrigger.disabled = true;
            if (toHidden) toHidden.value = 'Present';
            if (toText) { toText.textContent = 'Present'; toText.classList.remove('is-placeholder'); }
            toPickerWrap.style.opacity = '0.5';
            toPickerWrap.style.pointerEvents = 'none';
          } else {
            if (toTrigger) toTrigger.disabled = false;
            if (toHidden) toHidden.value = '';
            if (toText) { toText.textContent = 'To'; toText.classList.add('is-placeholder'); }
            toPickerWrap.style.opacity = '';
            toPickerWrap.style.pointerEvents = '';
          }
          saveProgress();
        });
      });
    }
// =============================================
    // CALENDAR DATE PICKER INITIALIZATION
    // =============================================
    function initCalendarPickers(container) {
      var pickers = container.querySelectorAll('[data-cal-picker]');
      pickers.forEach(function(picker) {
        if (picker.dataset.calInit) return;
        picker.dataset.calInit = '1';

        var trigger = picker.querySelector('[data-cal-trigger]');
        var popup = picker.querySelector('[data-cal-popup]');
        var hiddenInput = picker.querySelector('[data-cal-value]');
        var triggerText = trigger.querySelector('.nv-wiz-cal-trigger-text');
        var monthSelect = popup.querySelector('[data-cal-month-select]');
        var yearSelect = popup.querySelector('[data-cal-year-select]');
        var daysGrid = popup.querySelector('[data-cal-days]');
        var prevBtn = popup.querySelector('[data-cal-prev]');
        var nextBtn = popup.querySelector('[data-cal-next]');
        var todayBtn = popup.querySelector('[data-cal-today]');

        var maxDateStr = picker.dataset.calMax || null;
        var maxDate = maxDateStr ? new Date(maxDateStr + 'T23:59:59') : null;

        var today = new Date();
        today.setHours(0,0,0,0);
        var viewMonth = today.getMonth();
        var viewYear = today.getFullYear();
        var selectedDate = null;

        if (hiddenInput.value) {
          var parts = hiddenInput.value.split('-');
          if (parts.length === 3) {
            var pY = parseInt(parts[0], 10);
            var pM = parseInt(parts[1], 10) - 1;
            var pD = parseInt(parts[2], 10);
            selectedDate = new Date(pY, pM, pD);
            viewMonth = pM;
            viewYear = pY;
            triggerText.textContent = calMonthNames[pM] + ' ' + pD + ', ' + pY;
            triggerText.classList.remove('is-placeholder');
          }
        }

        function isDateDisabled(year, month, day) {
          if (!maxDate) return false;
          var d = new Date(year, month, day);
          return d > maxDate;
        }

        function renderDays() {
          monthSelect.value = viewMonth;
          yearSelect.value = viewYear;
          var firstDay = new Date(viewYear, viewMonth, 1).getDay();
          var daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();
          var daysInPrev = new Date(viewYear, viewMonth, 0).getDate();
          var html = '';
          var now = new Date(); now.setHours(0,0,0,0);
          var nowKey = now.getFullYear() + '-' + now.getMonth() + '-' + now.getDate();

          for (var p = firstDay - 1; p >= 0; p--) {
            var pd = daysInPrev - p;
            var pm = viewMonth - 1; var py = viewYear;
            if (pm < 0) { pm = 11; py--; }
            var dis = isDateDisabled(py, pm, pd) ? ' is-disabled' : '';
            html += '<button type="button" class="nv-wiz-cal-day is-outside' + dis + '" data-cal-day-outside="prev" data-day="' + pd + '"' + (dis ? ' disabled' : '') + '>' + pd + '</button>';
          }

          for (var d = 1; d <= daysInMonth; d++) {
            var dayKey = viewYear + '-' + viewMonth + '-' + d;
            var cls = 'nv-wiz-cal-day';
            if (dayKey === nowKey) cls += ' is-today';
            if (selectedDate && d === selectedDate.getDate() && viewMonth === selectedDate.getMonth() && viewYear === selectedDate.getFullYear()) cls += ' is-selected';
            if (isDateDisabled(viewYear, viewMonth, d)) cls += ' is-disabled';
            html += '<button type="button" class="' + cls + '" data-day="' + d + '"' + (cls.indexOf('is-disabled') > -1 ? ' disabled' : '') + '>' + d + '</button>';
          }

          var totalCells = firstDay + daysInMonth;
          var remaining = totalCells <= 35 ? 35 - totalCells : 42 - totalCells;
          for (var n = 1; n <= remaining; n++) {
            var nm = viewMonth + 1; var ny = viewYear;
            if (nm > 11) { nm = 0; ny++; }
            var dis2 = isDateDisabled(ny, nm, n) ? ' is-disabled' : '';
            html += '<button type="button" class="nv-wiz-cal-day is-outside' + dis2 + '" data-cal-day-outside="next" data-day="' + n + '"' + (dis2 ? ' disabled' : '') + '>' + n + '</button>';
          }
          daysGrid.innerHTML = html;
        }

        function selectDate(year, month, day) {
          if (isDateDisabled(year, month, day)) return;
          selectedDate = new Date(year, month, day);
          var mm = String(month + 1).padStart(2, '0');
          var dd = String(day).padStart(2, '0');
          hiddenInput.value = year + '-' + mm + '-' + dd;
          triggerText.textContent = calMonthNames[month] + ' ' + day + ', ' + year;
          triggerText.classList.remove('is-placeholder');
          popup.classList.remove('is-open');
          saveProgress();
          hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        function openPopup() {
          document.querySelectorAll('.nv-wiz-cal-popup.is-open').forEach(function(p) { if (p !== popup) p.classList.remove('is-open'); });
          document.querySelectorAll('.nv-wiz-date-dropdown.is-open, .nv-wiz-month-dropdown.is-open').forEach(function(d) { d.classList.remove('is-open'); });
          if (selectedDate) { viewMonth = selectedDate.getMonth(); viewYear = selectedDate.getFullYear(); }
          renderDays();
          popup.classList.add('is-open');
          var rect = popup.getBoundingClientRect();
          if (rect.right > window.innerWidth - 8) popup.classList.add('is-flip-right');
          else popup.classList.remove('is-flip-right');
        }

        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          if (popup.classList.contains('is-open')) popup.classList.remove('is-open');
          else openPopup();
        });
        prevBtn.addEventListener('click', function(e) { e.preventDefault(); viewMonth--; if (viewMonth < 0) { viewMonth = 11; viewYear--; } renderDays(); });
        nextBtn.addEventListener('click', function(e) { e.preventDefault(); viewMonth++; if (viewMonth > 11) { viewMonth = 0; viewYear++; } renderDays(); });
        monthSelect.addEventListener('change', function() { viewMonth = parseInt(monthSelect.value, 10); renderDays(); });
        yearSelect.addEventListener('change', function() { viewYear = parseInt(yearSelect.value, 10); renderDays(); });
        todayBtn.addEventListener('click', function(e) { e.preventDefault(); selectDate(today.getFullYear(), today.getMonth(), today.getDate()); });

        daysGrid.addEventListener('click', function(e) {
          var btn = e.target.closest('.nv-wiz-cal-day');
          if (!btn || btn.disabled) return;
          e.preventDefault();
          var day = parseInt(btn.dataset.day, 10);
          var outside = btn.dataset.calDayOutside;
          var selMonth = viewMonth; var selYear = viewYear;
          if (outside === 'prev') { selMonth--; if (selMonth < 0) { selMonth = 11; selYear--; } }
          else if (outside === 'next') { selMonth++; if (selMonth > 11) { selMonth = 0; selYear++; } }
          selectDate(selYear, selMonth, day);
        });

        popup.addEventListener('keydown', function(e) {
          if (e.key === 'Escape') { popup.classList.remove('is-open'); trigger.focus(); }
        });
      });
    }

    document.addEventListener('click', function(e) {
      if (!e.target.closest('[data-cal-picker]')) {
        document.querySelectorAll('.nv-wiz-cal-popup.is-open').forEach(function(p) { p.classList.remove('is-open'); });
      }
    });
    // =============================================
    // EMERGENCY CONTACTS (REPEATABLE)
    // =============================================

    function renderEmergencyContactCard(index, block) {
      var html = '<div class="nv-wiz-emergency-card" data-emergency-index="' + index + '">';
      html += '<div class="nv-wiz-emergency-header"><h5 class="nv-wiz-emergency-title">Emergency Contact ' + index + '</h5>';
      if (index > 1) html += '<button type="button" class="nv-wiz-emergency-remove" data-remove-emergency="' + index + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"></path></svg></button>';
      html += '</div>';
      html += '<div class="nv-wiz-emergency-fields">';
      if (block.showEmergencyName) {
        html += '<div class="nv-wiz-field"><label class="nv-wiz-label">' + escapeHtml(block.labelEmergencyName) + renderRequiredIndicator(block.requireEmergencyName && index === 1) + '</label>';
        html += '<input type="text" name="contact[emergency_' + index + '_name]" class="nv-wiz-input" placeholder="' + escapeHtml(block.placeholderEmergencyName) + '" data-field="emergency_' + index + '_name"' + (block.requireEmergencyName && index === 1 ? ' required' : '') + '></div>';
      }
      if (block.showEmergencyPhone) {
        html += '<div class="nv-wiz-field"><label class="nv-wiz-label">' + escapeHtml(block.labelEmergencyPhone) + renderRequiredIndicator(block.requireEmergencyPhone && index === 1) + '</label>';
        html += '<input type="tel" name="contact[emergency_' + index + '_phone]" class="nv-wiz-input" placeholder="' + escapeHtml(block.placeholderEmergencyPhone) + '" data-field="emergency_' + index + '_phone"' + (block.requireEmergencyPhone && index === 1 ? ' required' : '') + '></div>';
      }
      if (block.showEmergencyRelationship) {
        html += '<div class="nv-wiz-field"><label class="nv-wiz-label">' + escapeHtml(block.labelEmergencyRelationship) + renderRequiredIndicator(block.requireEmergencyRelationship && index === 1) + '</label>';
        html += '<input type="text" name="contact[emergency_' + index + '_relationship]" class="nv-wiz-input" placeholder="' + escapeHtml(block.placeholderEmergencyRelationship) + '" data-field="emergency_' + index + '_relationship"' + (block.requireEmergencyRelationship && index === 1 ? ' required' : '') + '></div>';
      }
      html += '</div></div>';
      return html;
    }

    function addEmergencyContact(container, block) {
      if (emergencyContactCount >= maxEmergencyContacts) return;
      emergencyContactCount++;
      var cardsWrapper = container.querySelector('[data-emergency-contacts-list]');
      if (!cardsWrapper) return;
      cardsWrapper.insertAdjacentHTML('beforeend', renderEmergencyContactCard(emergencyContactCount, block));
      updateAddEmergencyButton(container);
      renumberEmergencyCards(container);
      saveProgress();
    }

    function removeEmergencyContact(container, index) {
      var card = container.querySelector('[data-emergency-index="' + index + '"]');
      if (card) { card.remove(); emergencyContactCount--; renumberEmergencyCards(container); updateAddEmergencyButton(container); saveProgress(); }
    }

    function renumberEmergencyCards(container) {
      var cards = container.querySelectorAll('.nv-wiz-emergency-card');
      cards.forEach(function(card, i) {
        var num = i + 1;
        card.dataset.emergencyIndex = num;
        var title = card.querySelector('.nv-wiz-emergency-title');
        if (title) title.textContent = 'Emergency Contact ' + num;
        var removeBtn = card.querySelector('.nv-wiz-emergency-remove');
        if (removeBtn) removeBtn.dataset.removeEmergency = num;
      });
      emergencyContactCount = cards.length;
    }

    function updateAddEmergencyButton(container) {
      var btn = container.querySelector('[data-add-emergency]');
      if (btn) {
        if (emergencyContactCount >= maxEmergencyContacts) {
          btn.style.display = 'none';
        } else {
          btn.style.display = '';
          btn.disabled = false;
        }
      }
    }

    function addEmployer(container, block) {
      if (employerCount >= maxEmployers) return;
      employerCount++;
      var cardsWrapper = container.querySelector('[data-employers-list]');
      if (!cardsWrapper) return;
      cardsWrapper.insertAdjacentHTML('beforeend', renderEmployerCard(employerCount, block));
      var newCard = cardsWrapper.querySelector('[data-employer-index="' + employerCount + '"]');
      if (newCard) { initDatePickers(newCard); initCalendarPickers(newCard); initPresentToggle(newCard); }
      updateAddEmployerButton(container);
      renumberEmployerCards(container);
      saveProgress();
    }

    function removeEmployer(container, index) {
      var card = container.querySelector('[data-employer-index="' + index + '"]');
      if (card) { card.remove(); employerCount--; renumberEmployerCards(container); updateAddEmployerButton(container); saveProgress(); }
    }

    function renumberEmployerCards(container) {
      var cards = container.querySelectorAll('.nv-wiz-employer-card');
      cards.forEach(function(card, i) {
        var num = i + 1;
        card.dataset.employerIndex = num;
        var title = card.querySelector('.nv-wiz-employer-title');
        if (title) title.textContent = 'Employer ' + num;
        var removeBtn = card.querySelector('.nv-wiz-employer-remove');
        if (removeBtn) removeBtn.dataset.removeEmployer = num;
      });
      employerCount = cards.length;
    }

    function updateAddEmployerButton(container) {
      var btn = container.querySelector('[data-add-employer]');
      if (btn) {
        if (employerCount >= maxEmployers) {
          btn.style.display = 'none';
        } else {
          btn.style.display = '';
          btn.disabled = false;
          var textSpan = btn.querySelector('span');
          if (textSpan && btn.dataset.addTextFirst && btn.dataset.addTextAnother) {
            textSpan.textContent = employerCount === 0 ? btn.dataset.addTextFirst : btn.dataset.addTextAnother;
          }
        }
      }
    }

    // =============================================
    // REFERENCES
    // =============================================

    function renderReferenceCard(index, block) {
      var isRequired = block && block.requireReferences;
      var refGrid = block && block.referenceInnerGrid ? block.referenceInnerGrid : '3';
      
      // Get customizable text from block settings
      var nameLabel = (block && block.referenceNameLabel) || 'Reference Name';
      var namePlaceholder = (block && block.referenceNamePlaceholder) || 'Full name';
      var relationshipLabel = (block && block.referenceRelationshipLabel) || 'Relationship';
      var relationshipPlaceholder = (block && block.referenceRelationshipPlaceholder) || 'e.g. Former supervisor, colleague';
      var phoneLabel = (block && block.referencePhoneLabel) || 'Phone';
      var phonePlaceholder = (block && block.referencePhonePlaceholder) || '(555) 555-5555';
      var emailLabel = (block && block.referenceEmailLabel) || 'Email';
      var emailPlaceholder = (block && block.referenceEmailPlaceholder) || 'email@example.com';

      var html = '<div class="nv-wiz-reference-card" data-reference-index="' + index + '" data-inner-grid="' + refGrid + '">';
      html += '<div class="nv-wiz-reference-header"><h5 class="nv-wiz-reference-title">Reference ' + index + '</h5>';
      html += '<button type="button" class="nv-wiz-reference-remove" data-remove-reference="' + index + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"></path></svg></button></div>';
      html += '<div class="nv-wiz-reference-fields">';
      html += '<div class="nv-wiz-field"><label class="nv-wiz-label">' + nameLabel + (isRequired && index === 1 ? renderRequiredIndicator(true) : '') + '</label>';
      html += '<input type="text" name="contact[reference_' + index + '_name]" class="nv-wiz-input" placeholder="' + namePlaceholder + '" data-field="reference_' + index + '_name"' + (isRequired && index === 1 ? ' required' : '') + '></div>';
      html += '<div class="nv-wiz-field"><label class="nv-wiz-label">' + relationshipLabel + '</label><input type="text" name="contact[reference_' + index + '_relationship]" class="nv-wiz-input" placeholder="' + relationshipPlaceholder + '" data-field="reference_' + index + '_relationship"></div>';
      html += '<div class="nv-wiz-field"><label class="nv-wiz-label">' + phoneLabel + '</label><input type="tel" name="contact[reference_' + index + '_phone]" class="nv-wiz-input" placeholder="' + phonePlaceholder + '" data-field="reference_' + index + '_phone"></div>';
      html += '<div class="nv-wiz-field"><label class="nv-wiz-label">' + emailLabel + '</label><input type="email" name="contact[reference_' + index + '_email]" class="nv-wiz-input" placeholder="' + emailPlaceholder + '" data-field="reference_' + index + '_email"></div>';
      html += '</div></div>';
      return html;
    }

    function addReference(container, block) {
      if (referenceCount >= maxReferences) return;
      referenceCount++;
      var cardsWrapper = container.querySelector('[data-references-list]');
      if (!cardsWrapper) return;
      cardsWrapper.insertAdjacentHTML('beforeend', renderReferenceCard(referenceCount, block));
      updateAddReferenceButton(container);
      renumberReferenceCards(container);
      saveProgress();
    }

    function removeReference(container, index) {
      var card = container.querySelector('[data-reference-index="' + index + '"]');
      if (card) { card.remove(); referenceCount--; renumberReferenceCards(container); updateAddReferenceButton(container); saveProgress(); }
    }

    function renumberReferenceCards(container) {
      var cards = container.querySelectorAll('.nv-wiz-reference-card');
      cards.forEach(function(card, i) {
        var num = i + 1;
        card.dataset.referenceIndex = num;
        var title = card.querySelector('.nv-wiz-reference-title');
        if (title) title.textContent = 'Reference ' + num;
        var removeBtn = card.querySelector('.nv-wiz-reference-remove');
        if (removeBtn) removeBtn.dataset.removeReference = num;
      });
      referenceCount = cards.length;
    }

    function updateAddReferenceButton(container) {
      var btn = container.querySelector('[data-add-reference]');
      if (btn) {
        if (referenceCount >= maxReferences) {
          btn.style.display = 'none';
        } else {
          btn.style.display = '';
          btn.disabled = false;
          var textSpan = btn.querySelector('span');
          if (textSpan && btn.dataset.addTextFirst && btn.dataset.addTextAnother) {
            textSpan.textContent = referenceCount === 0 ? btn.dataset.addTextFirst : btn.dataset.addTextAnother;
          }
        }
      }
    }

    // =============================================
    // CONFIRMATION DIALOG
    // =============================================

    function initConfirmDialog() {
      confirmOverlay = section.querySelector('#nv-wiz-confirm-' + sectionId);
      confirmText = section.querySelector('#nv-wiz-confirm-text-' + sectionId);
      if (!confirmOverlay) return;
      confirmOverlay.querySelector('[data-confirm-cancel]').addEventListener('click', function() { hideConfirmDialog(); });
      confirmOverlay.querySelector('[data-confirm-remove]').addEventListener('click', function() {
        if (pendingRemoval) {
          if (pendingRemoval.type === 'employer') removeEmployer(pendingRemoval.wrapper, pendingRemoval.index);
          else if (pendingRemoval.type === 'reference') removeReference(pendingRemoval.wrapper, pendingRemoval.index);
          else if (pendingRemoval.type === 'emergency') removeEmergencyContact(pendingRemoval.wrapper, pendingRemoval.index);
          pendingRemoval = null;
        }
        hideConfirmDialog();
      });
      confirmOverlay.addEventListener('click', function(e) { if (e.target === confirmOverlay) hideConfirmDialog(); });
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && confirmOverlay.classList.contains('is-visible')) hideConfirmDialog();
      });
    }

    function showConfirmDialog(type, wrapper, index, message) {
      if (!confirmOverlay) return;
      pendingRemoval = { type: type, wrapper: wrapper, index: index };
      if (confirmText) confirmText.textContent = message;
      confirmOverlay.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    }

    function hideConfirmDialog() {
      if (!confirmOverlay) return;
      confirmOverlay.classList.remove('is-visible');
      document.body.style.overflow = '';
      pendingRemoval = null;
    }

    function cardHasData(card) {
      var inputs = card.querySelectorAll('input, textarea, select');
      for (var i = 0; i < inputs.length; i++) {
        var input = inputs[i];
        if (input.type === 'checkbox' || input.type === 'radio') { if (input.checked) return true; }
        else if (input.type === 'hidden') { if (input.value && input.value.trim()) return true; }
        else { if (input.value && input.value.trim()) return true; }
      }
      return false;
    }

    // =============================================
    // RESUME UPLOAD
    // =============================================

    function formatFileSize(bytes) {
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
      return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    }

    function validateResumeFile(file) {
      var allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
      var allowedExtensions = ['.pdf', '.doc', '.docx'];
      var maxSize = 5 * 1024 * 1024;
      var fileName = file.name.toLowerCase();
      var hasValidExtension = allowedExtensions.some(function(ext) { return fileName.endsWith(ext); });
      if (!hasValidExtension && !allowedTypes.includes(file.type)) return { valid: false, error: 'Please upload a PDF, DOC, or DOCX file.' };
      if (file.size > maxSize) return { valid: false, error: 'File size must be less than 5MB.' };
      return { valid: true };
    }

    function initResumeUpload(container) {
      var wrapper = container.querySelector('[data-resume-wrapper]');
      if (!wrapper) return;
      var dropzone = wrapper.querySelector('[data-resume-dropzone]');
      var fileInput = wrapper.querySelector('[data-resume-input]');
      var preview = wrapper.querySelector('.nv-wiz-resume-preview');
      var filenameEl = wrapper.querySelector('.nv-wiz-resume-filename');
      var filesizeEl = wrapper.querySelector('.nv-wiz-resume-filesize');
      var removeBtn = wrapper.querySelector('[data-resume-remove]');
      var errorEl = wrapper.querySelector('.nv-wiz-resume-error');
      if (!dropzone || !fileInput) return;
      dropzone.addEventListener('click', function(e) {
        if (e.target.closest('[data-resume-remove]')) return;
        fileInput.click();
      });
      dropzone.addEventListener('dragover', function(e) { e.preventDefault(); dropzone.classList.add('is-dragover'); });
      dropzone.addEventListener('dragleave', function(e) { e.preventDefault(); dropzone.classList.remove('is-dragover'); });
      dropzone.addEventListener('drop', function(e) {
        e.preventDefault();
        dropzone.classList.remove('is-dragover');
        if (e.dataTransfer.files.length > 0) handleResumeFile(e.dataTransfer.files[0]);
      });
      fileInput.addEventListener('change', function() { if (fileInput.files.length > 0) handleResumeFile(fileInput.files[0]); });
      if (removeBtn) removeBtn.addEventListener('click', function(e) { e.stopPropagation(); clearResumeFile(); });
      function handleResumeFile(file) {
        var validation = validateResumeFile(file);
        if (!validation.valid) { showResumeError(validation.error); return; }
        hideResumeError();
        var reader = new FileReader();
        reader.onload = function(e) {
          resumeFileData = { filename: file.name, content_type: file.type || 'application/octet-stream', size: file.size, data_base64: e.target.result.split(',')[1] };
          if (filenameEl) filenameEl.textContent = file.name;
          if (filesizeEl) filesizeEl.textContent = formatFileSize(file.size);
          dropzone.classList.add('has-file');
          saveProgress();
        };
        reader.readAsDataURL(file);
      }
      function clearResumeFile() {
        resumeFileData = null;
        fileInput.value = '';
        dropzone.classList.remove('has-file');
        if (filenameEl) filenameEl.textContent = '';
        if (filesizeEl) filesizeEl.textContent = '';
        hideResumeError();
        saveProgress();
      }
      function showResumeError(message) { if (errorEl) { errorEl.textContent = message; errorEl.classList.add('is-visible'); } }
      function hideResumeError() { if (errorEl) errorEl.classList.remove('is-visible'); }
    }

    function showSuccessState() {
      var formWrapper = section.querySelector('.nv-wiz-form-wrapper');
      if (formWrapper) {
        var successTitle = section.dataset.successTitle || 'Application Submitted!';
        var successMessage = section.dataset.successMessage || 'Thank you for applying. We will review your application and get back to you soon.';
        var applyAgainText = section.dataset.applyAgainText || 'Submit Another Application';
        formWrapper.innerHTML = '<div class="nv-wiz-success"><div class="nv-wiz-success-icon">✓</div><h3 class="nv-wiz-success-title">' + escapeHtml(successTitle) + '</h3><p class="nv-wiz-success-text">' + escapeHtml(successMessage) + '</p><button type="button" class="nv-wiz-success-btn" onclick="window.location.href=window.location.pathname;">' + escapeHtml(applyAgainText) + '</button></div>';
        setTimeout(function() {
          var scrollOffset = parseInt(section.dataset.scrollOffset || '120', 10);
          scrollToElement(section, scrollOffset);
        }, 100);
      }
      try { sessionStorage.removeItem(storageKey); localStorage.removeItem(pendingSubmitKey); } catch(e) {}
    }

    // =============================================
    // INITIALIZATION
    // =============================================

    function init() {
      parseConditionalFields();
      organizeSteps();
      renderAllSteps();
      buildStepDots();
      loadProgress();
      // Refresh all section group and field group statuses after session restore
      var allSectionGroups = section.querySelectorAll('.nv-wiz-section-group');
      allSectionGroups.forEach(function(groupEl) {
        updateSectionCompleteStatus(groupEl);
      });
      var allFieldGroups = section.querySelectorAll('[data-field-group]');
      allFieldGroups.forEach(function(fg) {
        updateFieldGroupStatus(fg);
      });
      initEventHandlers();
      initSbsCardHovers();
      initAgeVerification();
      goToStep(0);
      setTimeout(function() {
        var roleValue = null;
        var roleField = form.querySelector('[name="contact[role]"]');
        if (roleField && roleField.value) roleValue = roleField.value;
        var roleSelect = form.querySelector('[data-role-select]');
        if (roleSelect && roleSelect.value) updateConditionalFieldsVisibility(roleSelect.value);
        if (roleSelect && !roleSelect.value) {
          try {
            var saved = sessionStorage.getItem(storageKey);
            if (saved) {
              var data = JSON.parse(saved);
              if (data['contact[role]']) { roleSelect.value = data['contact[role]']; updateConditionalFieldsVisibility(data['contact[role]']); }
            }
          } catch(e) {}
        }
        if (!roleValue) {
          try {
            var saved = sessionStorage.getItem(storageKey);
            if (saved) {
              var data = JSON.parse(saved);
              if (data['contact[role]']) { roleValue = data['contact[role]']; if (roleField) roleField.value = roleValue; }
            }
          } catch(e) {}
        }
        if (!roleValue) {
          try {
            var globalRole = sessionStorage.getItem('nv_selected_role');
            if (globalRole) { roleValue = globalRole; if (roleField) roleField.value = globalRole; }
          } catch(e) {}
        }
        if (roleValue) updateRoleTether(roleValue);
        if (roleField) {
          roleField.addEventListener('change', function() {
            updateRoleTether(roleField.value);
            updateConditionalFieldsVisibility(roleField.value);
            saveProgress();
          });
        }
        window.addEventListener('nv:jobsRoleSelected', function(e) {
          var newRole = e.detail && e.detail.role ? e.detail.role : null;
          if (newRole && roleField) { roleField.value = newRole; updateRoleTether(newRole); saveProgress(); }
        });
      }, 100);
      initCalendarPickers(stepsContainer);
      var workHistoryWrapper = stepsContainer.querySelector('[data-work-history-wrapper]');
      if (workHistoryWrapper) {
        initDatePickers(workHistoryWrapper);
        initCalendarPickers(workHistoryWrapper);
        initPresentToggle(workHistoryWrapper);
        if (workHistoryWrapper.dataset.showFirst === 'false') {
          employerCount = 0;
        }
      }
      var referencesWrapper = stepsContainer.querySelector('[data-references-wrapper]');
      if (referencesWrapper && referencesWrapper.dataset.showFirst === 'false') {
        referenceCount = 0;
      }
      var resumeWrapper = stepsContainer.querySelector('[data-resume-wrapper]');
      if (resumeWrapper) initResumeUpload(stepsContainer);
      initConfirmDialog();
    }

    init();
  }
})();